<!--template v-for="(item, i) in lineInfo"-->
<template>
  <div>
    <b-container class="bv-example-row">
      <b-row :class="{ 'd-none': isHideQuote }">
        <b-col>
          <div class="card card-custom gutter-b">
            <div class="card-header border-0 py-5">
              <h3 class="card-title align-items-start flex-column">
                <span class="card-label font-weight-bolder text-dark">
                  {{ $t("TRANSLATOR.GETQUOTE", { msg: "GETQUOTE" }) }}
                </span>
                <span class="text-muted mt-3 font-weight-bold font-size-sm">{{ $t("TRANSLATOR.LINE", { msg: "LINE" }) }}
                  {{ lineId }}</span>
              </h3>
              <div class="card-toolbar">
                <a @click="GetQuoteToggl" class="ml-5 btn btn-secondary font-weight-bolder font-size-sm">{{ $t('TRANSLATOR.HIDEQUOTE') }}</a>
              </div>
            </div>

            <div class="card-body">
              <!-- <form class="form"> -->
              <div class="form-group row mb-3">
                <label class="col-xl-3 col-lg-3 col-form-label text-right">{{ $t('FORM.TO') }}</label>
                <div class="col-lg-9 col-xl-6">
                  <input ref="QuoteSubject" class="form-control form-control-lg form-control-solid" type="text"
                    :value="toSent" @change="setTomail" />
                </div>
              </div>
              <div class="form-group row mb-3">
                <label class="col-xl-3 col-lg-3 col-form-label text-right">{{ $t('FORM.FROM') }}</label>
                <div class="col-lg-9 col-xl-6">
                  <input ref="QuoteSubject" class="form-control form-control-lg form-control-solid" type="text" disabled
                    :value="userEmail" />
                  <span class="form-text text-muted">{{ userName }}</span>
                </div>
              </div>
              <div class="form-group row mb-3">
                <label class="col-xl-3 col-lg-3 col-form-label text-right">{{ $t('FORM.SUBJECT') }}</label>
                <div class="col-lg-9 col-xl-6">
                  <input ref="QuoteSubject" class="form-control form-control-lg form-control-solid" type="text"
                    v-model="QuoteSubject" disabled />
                  <!-- <span class="form-text text-muted">{{ QuoteSubject }}</span> -->
                </div>
              </div>
              <div class="form-group row mb-3">
                <label class="col-xl-3 col-lg-3 col-form-label text-right">{{ $t('FORM.SELECT_PARTS') }}</label>

                <div class="col-lg-9 col-xl-6">
                  <div :key="row.id" v-for="row in Parts" class="d-flex align-items-center flex-grow-1">
                    <label class="checkbox checkbox-lg checkbox-lg checkbox-single flex-shrink-0 mr-4">
                      <input type="checkbox" :id="row.id" :value="row.PartsLabel" @change="handleChange" />
                      <span></span>
                    </label>
                    <div class="d-flex flex-wrap align-items-center justify-content-between w-100">
                      <div class="d-flex flex-column align-items-cente py-2 w-75">
                        <span class="text-dark-75 font-weight-bold font-size-lg mb-1">{{ row.PartsLabel }}</span>
                      </div>
                      <!-- <span class="label label-lg label-inline font-weight-bold py-4"
                    v-bind:class="`label-light-success`"
                    >status</span> -->
                      <!-- <span class="form-text text-muted">{{ row.id }}</span> -->
                    </div>
                  </div>
                  <!-- <div class="d-flex align-items-center flex-grow-1">
                <label class="checkbox checkbox-lg checkbox-lg checkbox-single flex-shrink-0 mr-4">
                  <input 
                    ref="DriveBearingChecked"
                    type="checkbox"
                    v-model="DriveBearingChecked"
                  />
                  <span></span>
                </label>
                <div class="d-flex flex-wrap align-items-center justify-content-between w-100">
                  <div class="d-flex flex-column align-items-cente py-2 w-75">
                    <span class="text-dark-75 font-weight-bold font-size-lg mb-1"
                      >Drive Bearing</span>
                  </div>
                    <span class="form-text text-muted">{{ DriveBearingChecked }}</span>
                </div>
              </div>

              <div class="d-flex align-items-center flex-grow-1">
                <label class="checkbox checkbox-lg checkbox-lg checkbox-single flex-shrink-0 mr-4">
                  <input 
                    ref="IdlerBearingChecked"
                    type="checkbox"
                    v-model="IdlerBearingChecked"
                  />
                  <span></span>
                </label>
                <div class="d-flex flex-wrap align-items-center justify-content-between w-100">
                  <div class="d-flex flex-column align-items-cente py-2 w-75">
                    <span class="text-dark-75 font-weight-bold font-size-lg mb-1"
                      >Idler Bearing</span>
                  </div>
                    <span class="form-text text-muted">{{ IdlerBearingChecked }}</span>
                </div>
              </div>

              <div class="d-flex align-items-center flex-grow-1">
                <label class="checkbox checkbox-lg checkbox-lg checkbox-single flex-shrink-0 mr-4">
                  <input 
                    ref="ChainChecked"
                    type="checkbox"
                    v-model="ChainChecked"
                  />
                  <span></span>
                </label>
                <div class="d-flex flex-wrap align-items-center justify-content-between w-100">
                  <div class="d-flex flex-column align-items-cente py-2 w-75">
                    <span class="text-dark-75 font-weight-bold font-size-lg mb-1"
                      >Chain & Belt</span>
                  </div>
                    <span class="form-text text-muted">{{ ChainChecked }}</span>
                </div>
              </div>
              
              <div class="d-flex align-items-center flex-grow-1">
                <label class="checkbox checkbox-lg checkbox-lg checkbox-single flex-shrink-0 mr-4">
                  <input 
                    ref="DriveSprocketChecked"
                    type="checkbox"
                    v-model="DriveSprocketChecked"
                  />
                  <span></span>
                </label>
                <div class="d-flex flex-wrap align-items-center justify-content-between w-100">
                  <div class="d-flex flex-column align-items-cente py-2 w-75">
                    <span class="text-dark-75 font-weight-bold font-size-lg mb-1"
                      >Drive Sprocket</span>
                  </div>
                    <span class="form-text text-muted">{{ DriveSprocketChecked }}</span>
                </div>
              </div>
              
              <div class="d-flex align-items-center flex-grow-1">
                <label class="checkbox checkbox-lg checkbox-lg checkbox-single flex-shrink-0 mr-4">
                  <input 
                    ref="IdlerSprocketChecked"
                    type="checkbox"
                    v-model="IdlerSprocketChecked"
                  />
                  <span></span>
                </label>
                <div class="d-flex flex-wrap align-items-center justify-content-between w-100">
                  <div class="d-flex flex-column align-items-cente py-2 w-75">
                    <span class="text-dark-75 font-weight-bold font-size-lg mb-1"
                      >Idler Sprocket</span>
                  </div>
                    <span class="form-text text-muted">{{ IdlerSprocketChecked }}</span>
                </div>
              </div>
              
              <div class="d-flex align-items-center flex-grow-1">
                <label class="checkbox checkbox-lg checkbox-lg checkbox-single flex-shrink-0 mr-4">
                  <input 
                    ref="CurveChecked"
                    type="checkbox"
                    v-model="CurveChecked"
                  />
                  <span></span>
                </label>
                <div class="d-flex flex-wrap align-items-center justify-content-between w-100">
                  <div class="d-flex flex-column align-items-cente py-2 w-75">
                    <span class="text-dark-75 font-weight-bold font-size-lg mb-1"
                      >Curve</span>
                  </div>
                    <span class="form-text text-muted">{{ CurveChecked }}</span>
                </div>
              </div>
              
              <div class="d-flex align-items-center flex-grow-1">
                <label class="checkbox checkbox-lg checkbox-lg checkbox-single flex-shrink-0 mr-4">
                  <input 
                    ref="WearstripChecked"
                    type="checkbox"
                    v-model="WearstripChecked"
                  />
                  <span></span>
                </label>
                <div class="d-flex flex-wrap align-items-center justify-content-between w-100">
                  <div class="d-flex flex-column align-items-cente py-2 w-75">
                    <span class="text-dark-75 font-weight-bold font-size-lg mb-1"
                      >Wearstrip</span>
                  </div>
                    <span class="form-text text-muted">{{ WearstripChecked }}</span>
                </div>
              </div>
              
              <div class="d-flex align-items-center flex-grow-1">
                <label class="checkbox checkbox-lg checkbox-lg checkbox-single flex-shrink-0 mr-4">
                  <input 
                    ref="RollerChecked"
                    type="checkbox"
                    v-model="RollerChecked"
                  />
                  <span></span>
                </label>
                <div class="d-flex flex-wrap align-items-center justify-content-between w-100">
                  <div class="d-flex flex-column align-items-cente py-2 w-75">
                    <span class="text-dark-75 font-weight-bold font-size-lg mb-1"
                      >Roller</span>
                  </div>
                    <span class="form-text text-muted">{{ RollerChecked }}</span>
                </div>
              </div>
              
              <div class="d-flex align-items-center flex-grow-1">
                <label class="checkbox checkbox-lg checkbox-lg checkbox-single flex-shrink-0 mr-4">
                  <input 
                    ref="ComponentsChecked"
                    type="checkbox"
                    v-model="ComponentsChecked"
                  />
                  <span></span>
                </label>
                <div class="d-flex flex-wrap align-items-center justify-content-between w-100">
                  <div class="d-flex flex-column align-items-cente py-2 w-75">
                    <span class="text-dark-75 font-weight-bold font-size-lg mb-1"
                      >Components</span>
                  </div>
                    <span class="form-text text-muted">{{ ComponentsChecked }}</span>
                </div>
              </div> -->
                </div>
              </div>
              <div class="form-group row">
                <label class="col-xl-3 col-lg-3 col-form-label text-right">{{ $t('FORM.MESSAGE') }}</label>
                <div class="col-lg-9 col-xl-6">
                  <textarea ref="QuoteMessage" class="form-control form-control-lg form-control-solid" type="text"
                    v-model="QuoteMessage" rows="10" />
                  <!-- <span style="white-space: pre-line;" class="form-text text-muted">{{ QuoteMessageHtml }}</span> -->
                </div>
              </div>
              <b-row class="mt-10">
                <b-col xs="6" class="text-center">
                  <!-- <b-button type="reset" class="mt-3 w-100" size="md" @click="resetGetQuote">Reset</b-button> -->
                </b-col>
                <b-col xs="6" class="text-center">
                  <!-- <b-button class="mt-3 w-100" variant="primary" disabled size="md" v-if="!QuoteSubject && QuoteMessage === null">Submit</b-button> -->
                  <b-button type="submit" class="mt-3 w-100" variant="primary" size="md" @click="submitGetQuote"
                    v-if="QuoteSubject">Submit</b-button>
                </b-col>
              </b-row>
              <b-row class="sucess_massages mt-10">
                <b-col xs="12" class="text-center"></b-col>
                <b-col xs="12" class="text-center">
                  <!-- <b-alert variant="success" show>Success Alert</b-alert> -->
                  <b-alert :show="dismissCountDownGetQuote" dismissible fade variant="success" class="mt-5" @dismissed="dismissCountDownGetQuote = 0">
                    <!-- @dismiss-count-down="countDownChanged(dismissCountDown)" -->
                    Request for quotation successful
                  </b-alert><!-- Balise -->
                </b-col>
                <b-col xs="12" class="text-center">
                  <a @click="GetQuoteToggl" class="ml-5 btn btn-secondary font-weight-bolder font-size-sm">{{ $t('TRANSLATOR.HIDEQUOTE') }}</a>
                </b-col>
              </b-row>
              <!-- <alert :visible.sync="alertVisible"></alert> -->

              <!-- </form> -->
            </div>
          </div>
        </b-col>
      </b-row>

      <!-- ROW 1 -->
      <b-row>
        <b-col>
          <div class="card card-custom gutter-b">
            <!--begin::Header-->
            <div class="card-header border-0 pt-5">
              <h3 class="card-title align-items-start flex-column">
                <span class="card-label font-weight-bolder text-dark">
                  {{ $t("TRANSLATOR.NAME", { msg: "NAME" }) }} : {{ lineInfo.conveyorExtName }}
                  <br />
                  <span class="badge badge-light" style="cursor: pointer;">
                    <a @click="goToHome('prev')" class="font-weight-bolder font-size-md">&lt;</a>
                  </span>
                  {{ $t("TRANSLATOR.CONVEYOR", { msg: "CONVEYOR" }) }} {{ lineInfo.conveyorNumber }}
                  <span class="badge badge-light" style="cursor: pointer;">
                    <a @click="goToHome('next')" class="font-weight-bolder font-size-md">&gt;</a>
                  </span>
                </span>
                <!-- <span class="text-muted mt-3 font-weight-bold font-size-sm">{{ $t("TRANSLATOR.LINE", { msg: "LINE" }) }}
                  {{ lineId }}</span> -->
              </h3>

              <div class="card-toolbar">
                <a @click="goToHome('prev')" class="ml-5 btn btn-secondary font-weight-bolder font-size-sm">&lt;</a>
                <a @click="goToHome('next')" class="ml-5 btn btn-secondary font-weight-bolder font-size-sm">&gt;</a>
                <b-button  @click="goto('Maintenance')" class="ml-5">{{ $t("TRANSLATOR.MAINTENANCE_HISTORY") }}</b-button>
                <!-- <b-button  @click="InsertInspect" class="ml-5">{{ $t("TRANSLATOR.INSPECT_BUTTON") }}</b-button> -->

                <a @click="GetQuoteToggl" v-b-tooltip.hover.top="$t('TRANSLATOR.GETQUOTETOOLTIP')" class="ml-5 btn btn-primary font-weight-bolder font-size-sm">{{ $t("TRANSLATOR.GETQUOTE", { msg:"GETQUOTE" }) }}</a>

                <div v-if="isAdmin === 'True'" class="dropdown dropdown-inline ml-5">
                  <Dropdown3 @statusChange="handleStatusChange" :lineNumber="lineInfo.lineNumber"
                    :companyId="lineInfo.companyId" :conveyorNumber="lineInfo.conveyorNumber"></Dropdown3>
                </div>
              </div>
            </div>
    <div class="card-body py-0 pb-5">
      <b-row>
        <b-col md="6" class="text-center">
          <b-row>
            <b-col md="12" class="text-left">

                <span class="text-muted mt-3 font-weight-bold font-size-sm">{{ $t("TRANSLATOR.LINE", { msg: "LINE" }) }}
                  {{ lineId }}</span><br />

                <label class="lsi_date">
                  {{ $t('TRANSLATOR.LAST_INSPECTED') }} {{ UpdatedData }}
                  <span class="badge badge-light" style="cursor: pointer;">
                    <a @click="goto('Maintenance')" class="font-weight-bolder font-size-sm">
                      {{ $t('TRANSLATOR.VIEW_ALL') }}
                    </a>
                  </span>
                </label><br />
                <span class="text-muted mt-3 font-weight-bold font-size-sm">{{
                    newstatus
                }}</span><br />

              <b-alert :show="responseStatus == 200" dismissible fade variant="success">
                PDF Uploaded {{ this.responseText }}
              </b-alert>
              <b-form-file id="filePdfUpload" class="w-75" v-model="headerpdffile" :placeholder="$t('TRANSLATOR.CHOOSEFILEDROP')"
                :drop-placeholder="$t('TRANSLATOR.CHOOSEFILEDROP')" accept="application/pdf" @change="onFilePdfChange" style="display: none;"></b-form-file>
              <!-- <div id="preview"> -->
              <a v-if="pdfurl" class="w-75 btn btn-secondary font-weight-bolder font-size-sm"
              href="javascript:;"
              disabled
              v-b-tooltip.hover.top="$t('TRANSLATOR.OPEN_PDF')">
              <span class="svg-icon svg-icon-lg svg-icon-primary">
                  <inline-svg src="media/svg/icons/Files/Selected-file.svg" />
              </span>
                {{ pdfurl }}
              <span class="mb-3 text-danger" v-if="isPdfSize == true"><br />File size exceeds 5 MB </span>
              </a>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6" class="text-center">
                <b-button type="reset" class="mt-3 w-100" size="md" @click="resetPdf" v-if="headerpdffile">{{ $t('TRANSLATOR.CLEAR') }}</b-button>
            </b-col>
            <b-col md="6" class="text-center">
                <b-button type="submit" class="mt-3 mb-3 w-100" variant="primary" size="md" @click="UploadHeaderPdf" v-if="headerpdffile">{{ $t('TRANSLATOR.UPLOAD') }}</b-button>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="6" class="text-right">
          <a v-if="fullPdfurl" class="btn btn-secondary font-weight-bolder font-size-sm mr-5"
          v-b-tooltip.hover.top="$t('TRANSLATOR.OPEN_PDF')"
          v-b-modal.modal-pdf-viewer
          >
          <span class="svg-icon svg-icon-lg svg-icon-primary">
              <inline-svg src="media/svg/icons/Files/Selected-file.svg" />
          </span>
            {{ $t('TRANSLATOR.OPEN_PDF') }}
          </a>
          <span class="svg-icon svg-icon-lg svg-icon-primary" @click="choosePdfFiles()" v-b-tooltip.hover.top="$t('TRANSLATOR.UPLOAD_PDF')" style="cursor: pointer;">
            <inline-svg src="media/svg/icons/Files/File-plus.svg" />
          </span>
          <span class="mb-3 text-warning mt-3" v-if="headerpdffile && pdfurl"><br /><br /> This PDF will be overwritten with the new upload </span>
          <!-- <b-alert :show="headerpdffile && pdf" dismissible variant="warning" class="mt-3"> -->
            
          <!-- </b-alert> -->
        </b-col>
        <!-- <b-col md="3" class="text-center">
        </b-col> -->
      </b-row>
    </div>

            <div class="card-body">
              <b-row>
                <b-col md="3" class="text-center"></b-col>
                <b-col md="6" class="text-center">
                  <!-- <div id="preview"> -->
                    <b-img v-if="url" class="mb-3" :src="url" fluid center />
                  <!-- </div> -->
                  <b-alert class="mt-3" :show="dismissCountDown" dismissible fade variant="success" @dismiss-count-down="countDownChanged">
                    Image uploaded successfully
                  </b-alert>
                  <b-img v-if="!url" class="mb-3" :src=backgroundImage @error="backgroundImageLoadError" fluid center v-b-modal.modal-2></b-img>
                </b-col>
                <b-col md="3" class="text-center">
              <b-form-file v-if="isAdmin === 'True'" v-model="headerfile" :state="headerfile" :placeholder="$t('TRANSLATOR.CHOOSEFILEDROP')"
                :drop-placeholder="$t('TRANSLATOR.CHOOSEFILEDROP')" accept="image/jpeg,image/jpg,image/png" @change="onFileChange"></b-form-file>
                    <b-button type="reset" class="mt-3 w-100" size="md" @click="reset">{{ $t('TRANSLATOR.CLEAR') }}</b-button>
                    <b-button class="mt-3 w-100" variant="primary" disabled size="md" v-if="!headerfile">{{ $t('TRANSLATOR.UPLOAD') }}</b-button>
                    <b-button type="submit" class="mt-3 w-100" variant="primary" size="md" @click="UploadHeaderImage" v-if="headerfile">{{ $t('TRANSLATOR.UPLOAD') }}</b-button>
                </b-col>
              </b-row>
              <span class="mt-3 text-danger" v-if="isImageSize == true"> File size exceeds 9 MB </span>
              <b-row class="mt-8">
                <b-col cols="6" @click="goto('Motors')">
                  <ConveyorCard imgUrl="media/max-line/motors.jpg" :CardTitle="$t('PARTS.Motor')" :CardText="lineInfo.motorCode"
                    :CardStatus="lineInfo.motorStatus"></ConveyorCard>
                </b-col>
                <b-col cols="6" @click="goto('DriveBearings')">
                  <ConveyorCard imgUrl="media/max-line/bearings.jpg" :CardTitle="$t('PARTS.DriveBearing')"
                    :CardText="lineInfo.driveBearingCode" :CardStatus="lineInfo.driveBearingStatus" :idlerBearingCode="lineInfo.idlerBearingCode"></ConveyorCard>
                </b-col>
              </b-row>
              <b-row class="mt-8">
                <b-col cols="6" @click="goto('DriveSprockets')">
                  <ConveyorCard imgUrl="media/max-line/sprockets.jpg" :CardTitle="$t('PARTS.DriveSprocket')"
                    :CardText="lineInfo.driveSprocketCode" :CardStatus="lineInfo.driveSprocketStatus" :idlerSprocketCode="lineInfo.idlerSprocketCode"></ConveyorCard>
                </b-col>
                <b-col cols="6" @click="goto('ChainBelt')">
                  <ConveyorCard imgUrl="media/max-line/chainbelt.jpg" :CardTitle="$t('PARTS.ChainBelt')"
                    :CardText="lineInfo.chainBeltCode" :CardStatus="lineInfo.chainBeltStatus"></ConveyorCard>
                </b-col>
              </b-row>
              <b-row class="mt-8" v-show="(lineInfo.curveType != '' && lineInfo.curveAmount > 0) || (lineInfo.wearstripName != '' && lineInfo.wearstripStatus != '')">
                <b-col cols="6" @click="goto('Curves')" v-show="lineInfo.curveType != '' && lineInfo.curveAmount > 0">
                  <ConveyorCard imgUrl="media/max-line/curves.jpg" :CardTitle="$t('PARTS.Curve')" :CardText="lineInfo.curveType"
                    :CardStatus="lineInfo.curveStatus"></ConveyorCard>
                </b-col>
                <b-col cols="6" @click="goto('Wearstrip')" v-show="lineInfo.wearstripName != '' && lineInfo.wearstripStatus != ''">
                  <ConveyorCard imgUrl="media/max-line/wearstrip.jpg" :CardTitle="$t('PARTS.Wearstrip')"
                    :CardText="lineInfo.wearstripName" :CardStatus="lineInfo.wearstripStatus"></ConveyorCard>
                </b-col>
              </b-row>
              <b-row class="mt-8" v-show="(lineInfo.rollerName != '' && lineInfo.rollerCode != '' && lineInfo.rollerSeries != '') || (lineInfo.componentsName != '' || lineInfo.componentsAmount > 0 || lineInfo.componentsCode != '')">
                <b-col cols="6" @click="goto('Rollers')" v-show="lineInfo.rollerName != '' && lineInfo.rollerCode != '' && lineInfo.rollerSeries != ''">
                  <ConveyorCard imgUrl="media/max-line/rollers.jpg" :CardTitle="$t('PARTS.Roller')" :CardText="lineInfo.rollerCode"
                    :CardStatus="lineInfo.rollerStatus"></ConveyorCard>
                </b-col>
                <b-col cols="6" @click="goto('Components')" v-show="lineInfo.componentsName != '' || lineInfo.componentsAmount > 0 || lineInfo.componentsCode != ''">
                  <ConveyorCard imgUrl="media/max-line/components.jpg" :CardTitle="$t('PARTS.Components')"
                    :CardText="lineInfo.componentsCode" :CardStatus="lineInfo.componentsStatus"></ConveyorCard>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
      <!-- ROW 2 -->
      <b-row>
        <b-col>
          <!-- <div class="card card-custom gutter-b">
            <div class="card-header border-0 py-5">
              <h3 class="card-title align-items-start flex-column">
                <span class="card-label font-weight-bolder text-dark">
                  {{ $t("TRANSLATOR.CONVEYOR", { msg: "CONVEYOR" }) }}
                  {{ lineInfo.conveyorNumber }}
                </span>
                <span class="text-muted mt-3 font-weight-bold font-size-sm">{{ $t("TRANSLATOR.LINE", { msg: "LINE" }) }}
                  {{ lineId }}</span>
              </h3>
            </div>
            <div class="card-body py-0">
              <div class="table-responsive">
                <table class="table table-head-custom table-vertical-center striped" id="kt_advance_table_widget_4">
                  <tbody>
                    <ConveyorTableRow :label="$t('TRANSLATOR.NAME', { msg: 'NAME' })" :value="lineInfo.conveyorExtName">
                    </ConveyorTableRow>
                    <ConveyorTableRow :label="$t('TRANSLATOR.LINE', { msg: 'LINE' })" :value="lineInfo.lineNumber">
                    </ConveyorTableRow>
                    <ConveyorTableRow :label="$t('TRANSLATOR.CONVEYOR', { msg: 'CONVEYOR' })"
                      :value="lineInfo.conveyorNumber"></ConveyorTableRow>
                    <ConveyorTableRow :label="$t('TRANSLATOR.LASTCHECK')" :value="lineInfo.updated"></ConveyorTableRow>
                  </tbody>
                </table>
              </div>
            </div>
          </div> -->

          <div class="card card-custom gutter-b" ref="Motors" v-if="lineInfo.motorCode != ''">
            <div class="card-header border-0 py-5">
              <h3 class="card-title align-items-start flex-column">
                <span class="card-label font-weight-bolder text-dark">{{ $t('PARTS.Motor') }}</span>
              </h3>
              <div class="card-toolbar">
                <!-- ADD TO CART FUNCTION -->
                <!-- <b-alert
                  v-if="alert1.show"
                  :show="alert1.dismissCountDown"
                  dismissible
                  :variant="alert1.variant"
                  @dismissed="dismissAlert2(1)"
                  @dismiss-count-down="countDownChanged2(1, $event)"
                  class="mr-4"
                >
                {{ $t('ECOMMERCE.PRODUCT_ADDED_TO_CART') }}
                </b-alert>
                <div class="text-right">
               
                  <span @click="RemoveQty(0)" class="btn btn-xs btn-light-success btn-icon mr-2">
                    <i class="ki ki-minus icon-xs"></i>
                  </span>
                  {{ this.PartsInfo[0].Quantity }} x {{ this.lineInfo.motorMinOrderQty }}
                  <span @click="AddQty(0)" class="btn btn-xs btn-light-success btn-icon mr-4">
                    <i class="ki ki-plus icon-xs"></i>
                  </span>
                  <button @click="AddToCart(0),showAlert2(1)" class="btn btn-primary font-weight-bolder font-size-sm">
                    <span class="svg-icon svg-icon-md svg-icon-white">
                      <inline-svg src="media/svg/icons/Shopping/Cart2.svg" />
                    </span>
                    {{ $t('ECOMMERCE.ADDTOCART') }}
                </button>
                </div> -->
                <div class="dropdown dropdown-inline ml-4">
                  <ChangeStatusPart @statusChange="handleStatusChange" :lineNumber="lineInfo.lineNumber"
                    :companyId="lineInfo.companyId" :conveyorNumber="lineInfo.conveyorNumber" sparePart="[Motor status]"
                    :currentStatus="lineInfo.motorStatus" :userId="userId" :userEmail="userEmail" :userName="userName">
                  </ChangeStatusPart>
                </div>
              </div>
            </div>
            <div class="card-body py-0">
              <div class="table-responsive">
                <table class="table table-head-custom table-vertical-center striped" id="kt_advance_table_widget_4">
                  <tbody>
                    <ConveyorTableRow :label="$t('TRANSLATOR.NAME')" :value="lineInfo.motorName"></ConveyorTableRow>
                    <ConveyorTableRow label="Code" :value="lineInfo.motorCode" v-show="lineInfo.motorCodeExt === ''"></ConveyorTableRow>
                    <ConveyorTableRow label="Extern Code" :value="lineInfo.motorCodeExt" v-show="lineInfo.motorCodeExt != ''"></ConveyorTableRow>
                    <ConveyorTableRow :label="$t('TRANSLATOR.AMOUNT')" :value="lineInfo.motorAmount"></ConveyorTableRow>
                    <ConveyorTableRow :label="$t('TRANSLATOR.STOCK_LOCATION')" :value="lineInfo.motorStockLocation" v-show="lineInfo.motorStockLocation != ''"></ConveyorTableRow>
                    <ConveyorTableRow :label="$t('TRANSLATOR.NOTES')" :value="lineInfo.motorNotes" v-show="lineInfo.motorNotes != ''"></ConveyorTableRow>
                    <ConveyorTableRowStatus :label="$t('TRANSLATOR.STATUS')" :value="lineInfo.motorStatus"></ConveyorTableRowStatus>
                    <!-- <ConveyorTableRow :label="$t('ECOMMERCE.VIEW_PRODUCT')" :value="lineInfo.motorCode" :href="'#/shop/'+lineInfo.motorCategory+'/'+lineInfo.motorCode" target="_blank"></ConveyorTableRow> -->
                    <tr>
                      <td width="30%" style="min-width: 100px">
                        <b-col md="12" style="max-width: 150px;">
                          <b-card-img
                            :src="lineInfo.motorImgUrl"
                            class="rounded-0"
                          ></b-card-img>
                        </b-col>
                      </td>
                      <td width="70%" style="min-width: 110px">
          <div class="row" style="margin-right: 0px; margin-left: 0px;">
            <div class="col-6 col-md-4" v-if="lineInfo.motorS1 !== ''">
                <div class="mb-8 d-flex flex-column">
                    <span class="text-dark font-weight-bold mb-4">{{lineInfo.motorS1Label}}</span>
                    <span class="text-muted font-weight-bolder font-size-lg">{{lineInfo.motorS1}}</span>
                </div>
            </div>
            <div class="col-6 col-md-4" v-if="lineInfo.motorS2 !== ''">
                <div class="mb-8 d-flex flex-column">
                    <span class="text-dark font-weight-bold mb-4"> {{lineInfo.motorS2Label}}</span>
                    <span class="text-muted font-weight-bolder font-size-lg"> {{lineInfo.motorS2}} </span>
                </div>
            </div>
            <div class="col-6 col-md-4" v-if="lineInfo.motorS3 !== ''">
                <div class="mb-8 d-flex flex-column">
                    <span class="text-dark font-weight-bold mb-4"> {{lineInfo.motorS3Label}} </span>
                    <span class="text-muted font-weight-bolder font-size-lg"> {{lineInfo.motorS3}} </span>
                </div>
            </div>
            <div class="col-6 col-md-4" v-if="lineInfo.motorS4 !== ''">
                <div class="mb-8 d-flex flex-column">
                    <span class="text-dark font-weight-bold mb-4"> {{lineInfo.motorS4Label}} </span>
                    <span class="text-muted font-weight-bolder font-size-lg"> {{lineInfo.motorS4}} </span>
                </div>
            </div>
            <div class="col-6 col-md-4" v-if="lineInfo.motorS5 !== ''">
                <div class="mb-8 d-flex flex-column">
                    <span class="text-dark font-weight-bold mb-4"> {{lineInfo.motorS5Label}} </span>
                    <span class="text-muted font-weight-bolder font-size-lg"> {{lineInfo.motorS5}} </span>
                </div>
            </div>
            <div class="col-6 col-md-4" v-if="lineInfo.motorS6 !== ''">
                <div class="mb-8 d-flex flex-column">
                    <span class="text-dark font-weight-bold mb-4"> {{lineInfo.motorS6Label}} </span>
                    <span class="text-muted font-weight-bolder font-size-lg"> {{lineInfo.motorS6}} </span>
                </div>
            </div>
        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <!-- <div class="card-footer py-0">
              <b-row no-gutters>
                <b-col md="4" style="max-width: 200px;" class="p-5">
                  <b-card-img
                    :src="lineInfo.motorImgUrl"
                    class="rounded-0"
                  ></b-card-img>
                </b-col>
                <b-col md="8">
                  <b-card-body class="p-5">
        <div class="row">
            <div class="col-6 col-md-4" v-if="lineInfo.chainBeltS1 !== ''">
                <div class="mb-8 d-flex flex-column">
                    <span class="text-dark font-weight-bold mb-4">{{lineInfo.chainBeltS1Label}}</span>
                    <span class="text-muted font-weight-bolder font-size-lg">{{lineInfo.chainBeltS1}}</span>
                </div>
            </div>
            <div class="col-6 col-md-4" v-if="lineInfo.chainBeltS2 !== ''">
                <div class="mb-8 d-flex flex-column">
                    <span class="text-dark font-weight-bold mb-4"> {{lineInfo.chainBeltS2Label}} </span>
                    <span class="text-muted font-weight-bolder font-size-lg"> {{lineInfo.chainBeltS2}} </span>
                </div>
            </div>
            <div class="col-6 col-md-4" v-if="lineInfo.chainBeltS3 !== ''">
                <div class="mb-8 d-flex flex-column">
                    <span class="text-dark font-weight-bold mb-4"> {{lineInfo.chainBeltS3Label}} </span>
                    <span class="text-muted font-weight-bolder font-size-lg"> {{lineInfo.chainBeltS3}} </span>
                </div>
            </div>
            <div class="col-6 col-md-4" v-if="lineInfo.chainBeltS4 !== ''">
                <div class="mb-8 d-flex flex-column">
                    <span class="text-dark font-weight-bold mb-4"> {{lineInfo.chainBeltS4Label}} </span>
                    <span class="text-muted font-weight-bolder font-size-lg"> {{lineInfo.chainBeltS4}} </span>
                </div>
            </div>
            <div class="col-6 col-md-4" v-if="lineInfo.chainBeltS5 !== ''">
                <div class="mb-8 d-flex flex-column">
                    <span class="text-dark font-weight-bold mb-4"> {{lineInfo.chainBeltS5Label}} </span>
                    <span class="text-muted font-weight-bolder font-size-lg"> {{lineInfo.chainBeltS5}} </span>
                </div>
            </div>
            <div class="col-6 col-md-4" v-if="lineInfo.chainBeltS6 !== ''">
                <div class="mb-8 d-flex flex-column">
                    <span class="text-dark font-weight-bold mb-4"> {{lineInfo.chainBeltS6Label}} </span>
                    <span class="text-muted font-weight-bolder font-size-lg"> {{lineInfo.chainBeltS6}} </span>
                </div>
            </div>
        </div>
                  </b-card-body>
                </b-col>
              </b-row>
            </div> -->
          </div>

          <div class="card card-custom gutter-b" ref="DriveBearings" v-if="lineInfo.driveBearingCode != ''">
            <div class="card-header border-0 py-5">
              <h3 class="card-title align-items-start flex-column">
                <span class="card-label font-weight-bolder text-dark">{{ $t('PARTS.DriveBearing') }}</span>
              </h3>
              <div class="card-toolbar">
                <!-- <b-alert
                  v-if="alert2.show"
                  :show="alert2.dismissCountDown"
                  dismissible
                  :variant="alert2.variant"
                  @dismissed="dismissAlert2(2)"
                  @dismiss-count-down="countDownChanged2(2, $event)"
                  class="mr-4"
                >
                  Product added to cart
                </b-alert>
                <div class="text-right">
                  <span @click="RemoveQty(1)" class="btn btn-xs btn-light-success btn-icon mr-2">
                    <i class="ki ki-minus icon-xs"></i>
                  </span>
                  {{ this.PartsInfo[1].Quantity }} x {{ this.lineInfo.driveBearingMinOrderQty }}
                  <span @click="AddQty(1)" class="btn btn-xs btn-light-success btn-icon mr-4">
                    <i class="ki ki-plus icon-xs"></i>
                  </span>
                  <button @click="AddToCart(1),showAlert2(2)" class="btn btn-primary font-weight-bolder font-size-sm">
                    <span class="svg-icon svg-icon-md svg-icon-white">
                      <inline-svg src="media/svg/icons/Shopping/Cart2.svg" />
                    </span>
                    {{ $t('ECOMMERCE.ADDTOCART') }}
                </button>
                </div> -->
                <div class="dropdown dropdown-inline ml-4">
                  <ChangeStatusPart @statusChange="handleStatusChange" :lineNumber="lineInfo.lineNumber"
                    :companyId="lineInfo.companyId" :conveyorNumber="lineInfo.conveyorNumber"
                    sparePart="[Drive bearing status]" :currentStatus="lineInfo.driveBearingStatus" :userId="userId"
                    :userEmail="userEmail" :userName="userName">
                  </ChangeStatusPart>
                </div>
              </div>
            </div>
            <div class="card-body py-0">
              <div class="table-responsive">
                <table class="table table-head-custom table-vertical-center striped" id="kt_advance_table_widget_4">
                  <tbody>
                    <ConveyorTableRow :label="$t('TRANSLATOR.NAME')" :value="lineInfo.driveBearingName"
                      v-show="lineInfo.driveBearingName != ''"></ConveyorTableRow>
                    <ConveyorTableRow label="Code" :value="lineInfo.driveBearingCode" v-show="lineInfo.driveBearingCodeExt === ''"></ConveyorTableRow>
                    <ConveyorTableRow label="Extern Code" :value="lineInfo.driveBearingCodeExt" v-show="lineInfo.driveBearingCodeExt != ''"></ConveyorTableRow>
                    <ConveyorTableRow :label="$t('TRANSLATOR.AMOUNT')" :value="lineInfo.driveBearingAmount"></ConveyorTableRow>
                    <ConveyorTableRow :label="$t('TRANSLATOR.STOCK_LOCATION')" :value="lineInfo.driveBearingStockLocation" v-show="lineInfo.driveBearingStockLocation != ''"></ConveyorTableRow>
                    <ConveyorTableRow :label="$t('TRANSLATOR.NOTES')" :value="lineInfo.driveBearingNotes" v-show="lineInfo.driveBearingNotes != ''"></ConveyorTableRow>
                    <ConveyorTableRowStatus :label="$t('TRANSLATOR.STATUS')" :value="lineInfo.driveBearingStatus">
                    </ConveyorTableRowStatus>
                    <!-- <ConveyorTableRow :label="$t('ECOMMERCE.VIEW_PRODUCT')" :value="lineInfo.driveBearingCode" :href="'#/shop/Bearings/'+lineInfo.driveBearingCode"></ConveyorTableRow> -->
                    <tr>
                      <td width="30%" style="min-width: 100px">
                        <b-col md="12" style="max-width: 150px;">
                          <b-card-img
                            :src="lineInfo.driveBearingImgUrl"
                            class="rounded-0"
                          ></b-card-img>
                        </b-col>
                      </td>
                      <td width="70%" style="min-width: 110px">
        <div class="row" style="margin-right: 0px; margin-left: 0px;">
            <div class="col-6 col-md-4" v-if="lineInfo.driveBearingS1 !== ''">
                <div class="mb-8 d-flex flex-column">
                    <span class="text-dark font-weight-bold mb-4">{{lineInfo.driveBearingS1Label}}</span>
                    <span class="text-muted font-weight-bolder font-size-lg">{{lineInfo.driveBearingS1}}</span>
                </div>
            </div>
            <div class="col-6 col-md-4" v-if="lineInfo.driveBearingS2 !== ''">
                <div class="mb-8 d-flex flex-column">
                    <span class="text-dark font-weight-bold mb-4"> {{lineInfo.driveBearingS2Label}}</span>
                    <span class="text-muted font-weight-bolder font-size-lg"> {{lineInfo.driveBearingS2}} </span>
                </div>
            </div>
            <div class="col-6 col-md-4" v-if="lineInfo.driveBearingS3 !== ''">
                <div class="mb-8 d-flex flex-column">
                    <span class="text-dark font-weight-bold mb-4"> {{lineInfo.driveBearingS3Label}} </span>
                    <span class="text-muted font-weight-bolder font-size-lg"> {{lineInfo.driveBearingS3}} </span>
                </div>
            </div>
            <div class="col-6 col-md-4" v-if="lineInfo.driveBearingS4 !== ''">
                <div class="mb-8 d-flex flex-column">
                    <span class="text-dark font-weight-bold mb-4"> {{lineInfo.driveBearingS4Label}} </span>
                    <span class="text-muted font-weight-bolder font-size-lg"> {{lineInfo.driveBearingS4}} </span>
                </div>
            </div>
            <div class="col-6 col-md-4" v-if="lineInfo.driveBearingS5 !== ''">
                <div class="mb-8 d-flex flex-column">
                    <span class="text-dark font-weight-bold mb-4"> {{lineInfo.driveBearingS5Label}} </span>
                    <span class="text-muted font-weight-bolder font-size-lg"> {{lineInfo.driveBearingS5}} </span>
                </div>
            </div>
            <div class="col-6 col-md-4" v-if="lineInfo.driveBearingS6 !== ''">
                <div class="mb-8 d-flex flex-column">
                    <span class="text-dark font-weight-bold mb-4"> {{lineInfo.driveBearingS6Label}} </span>
                    <span class="text-muted font-weight-bolder font-size-lg"> {{lineInfo.driveBearingS6}} </span>
                </div>
            </div>
        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="card card-custom gutter-b" ref="IdlerBearings" v-show="lineInfo.idlerBearingCode != '' && lineInfo.idlerBearingAmount > 0">
            <div class="card-header border-0 py-5">
              <h3 class="card-title align-items-start flex-column">
                <span class="card-label font-weight-bolder text-dark">{{ $t('PARTS.IdlerBearing') }}</span>
              </h3>
              <div class="card-toolbar">
                <!-- <b-alert
                v-if="alert3.show"
                :show="alert3.dismissCountDown"
                dismissible
                :variant="alert3.variant"
                @dismissed="dismissAlert2(3)"
                @dismiss-count-down="countDownChanged2(3, $event)"
                class="mr-4"
                >
                  Product added to cart
                </b-alert>
                <div class="text-right">
                  <span @click="RemoveQty(2)" class="btn btn-xs btn-light-success btn-icon mr-2">
                    <i class="ki ki-minus icon-xs"></i>
                  </span>
                  {{ this.PartsInfo[2].Quantity }} x {{ this.lineInfo.idlerBearingMinOrderQty }}
                  <span @click="AddQty(2)" class="btn btn-xs btn-light-success btn-icon mr-4">
                    <i class="ki ki-plus icon-xs"></i>
                  </span>
                  <button @click="AddToCart(2),showAlert2(3)" class="btn btn-primary font-weight-bolder font-size-sm">
                    <span class="svg-icon svg-icon-md svg-icon-white">
                      <inline-svg src="media/svg/icons/Shopping/Cart2.svg" />
                    </span>
                    {{ $t('ECOMMERCE.ADDTOCART') }}
                </button>
                </div> -->
                <div class="dropdown dropdown-inline ml-4">
                  <ChangeStatusPart @statusChange="handleStatusChange" :lineNumber="lineInfo.lineNumber"
                    :companyId="lineInfo.companyId" :conveyorNumber="lineInfo.conveyorNumber"
                    sparePart="[Idler bearing status]" :currentStatus="lineInfo.idlerBearingStatus" :userId="userId"
                    :userEmail="userEmail" :userName="userName">
                  </ChangeStatusPart>
                </div>
              </div>
            </div>
            <div class="card-body py-0">
              <!--begin::Table-->
              <div class="table-responsive">
                <table class="table table-head-custom table-vertical-center striped" id="kt_advance_table_widget_4">
                  <tbody>
                    <ConveyorTableRow :label="$t('TRANSLATOR.NAME')" :value="lineInfo.idlerBearingName"
                      v-show="lineInfo.idlerBearingName != ''"></ConveyorTableRow>
                    <ConveyorTableRow label="Code" :value="lineInfo.idlerBearingCode" v-show="lineInfo.idlerBearingCode != '' && lineInfo.idlerBearingCodeExt === ''"></ConveyorTableRow>
                    <ConveyorTableRow label="Extern Code" :value="lineInfo.idlerBearingCodeExt" v-show="lineInfo.idlerBearingCodeExt != ''"></ConveyorTableRow>
                    <ConveyorTableRow :label="$t('TRANSLATOR.AMOUNT')" :value="lineInfo.idlerBearingAmount" v-show="lineInfo.idlerBearingAmount > 0"></ConveyorTableRow>
                    <ConveyorTableRow :label="$t('TRANSLATOR.STOCK_LOCATION')" :value="lineInfo.idlerBearingStockLocation" v-show="lineInfo.idlerBearingStockLocation != ''"></ConveyorTableRow>
                    <ConveyorTableRow :label="$t('TRANSLATOR.NOTES')" :value="lineInfo.idlerBearingNotes" v-show="lineInfo.idlerBearingNotes != ''"></ConveyorTableRow>
                    <ConveyorTableRowStatus :label="$t('TRANSLATOR.STATUS')" :value="lineInfo.idlerBearingStatus" v-show="lineInfo.idlerBearingStatus != ''">
                    </ConveyorTableRowStatus>
                    <!-- idlerBearingImgUrl -->
                    <!-- <ConveyorTableRow :label="$t('ECOMMERCE.VIEW_PRODUCT')" :value="lineInfo.idlerBearingCode" :href="'#/shop/'+lineInfo.idlerBearingCategory+'/'+lineInfo.idlerBearingCode" v-show="lineInfo.idlerBearingCode != ''"></ConveyorTableRow> -->
                  </tbody>
                </table>
              </div>
              <!--end::Table-->
            </div>
          </div>

          <div class="card card-custom gutter-b" ref="ChainBelt" v-if="lineInfo.chainBeltCode != ''">
            <div class="card-header border-0 py-5">
              <h3 class="card-title align-items-start flex-column">
                <span class="card-label font-weight-bolder text-dark">{{ $t('PARTS.ChainBelt') }}</span>
              </h3>
              <div class="card-toolbar">
                <!-- <b-alert
                v-if="alert4.show"
                :show="alert4.dismissCountDown"
                dismissible
                :variant="alert4.variant"
                @dismissed="dismissAlert2(4)"
                @dismiss-count-down="countDownChanged2(4, $event)"
                class="mr-4"
                >
                  Product added to cart
                </b-alert>
                <div class="text-right">
                  <span @click="RemoveQty(3)" class="btn btn-xs btn-light-success btn-icon mr-2">
                    <i class="ki ki-minus icon-xs"></i>
                  </span>
                  {{ this.PartsInfo[3].Quantity }} x {{ this.lineInfo.chainBeltMinOrderQty }}
                  <span @click="AddQty(3)" class="btn btn-xs btn-light-success btn-icon mr-4">
                    <i class="ki ki-plus icon-xs"></i>
                  </span>
                  <button @click="AddToCart(3),showAlert2(4)" class="btn btn-primary font-weight-bolder font-size-sm">
                    <span class="svg-icon svg-icon-md svg-icon-white">
                      <inline-svg src="media/svg/icons/Shopping/Cart2.svg" />
                    </span>
                    {{ $t('ECOMMERCE.ADDTOCART') }}
                </button>
                </div> -->
                <div class="dropdown dropdown-inline ml-4">
                  <ChangeStatusPart @statusChange="handleStatusChange" :lineNumber="lineInfo.lineNumber"
                    :companyId="lineInfo.companyId" :conveyorNumber="lineInfo.conveyorNumber"
                    sparePart="[Chain/Belt status]" :currentStatus="lineInfo.chainBeltStatus" :userId="userId"
                    :userEmail="userEmail" :userName="userName">
                  </ChangeStatusPart>
                </div>
              </div>
            </div>
            <div class="card-body py-0">
              <div class="table-responsive">
                <table class="table table-head-custom table-vertical-center striped" id="kt_advance_table_widget_4">
                  <tbody>
                    <ConveyorTableRow :label="$t('TRANSLATOR.NAME')" :value="lineInfo.chainBeltName"></ConveyorTableRow>
                    <ConveyorTableRow label="Code" :value="lineInfo.chainBeltCode" v-show="lineInfo.chainBeltCodeExt === ''"></ConveyorTableRow>
                    <ConveyorTableRow label="Extern Code" :value="lineInfo.chainBeltCodeExt" v-show="lineInfo.chainBeltCodeExt != ''"></ConveyorTableRow>
                    <ConveyorTableRow :label="$t('TRANSLATOR.TRACKS')" :value="lineInfo.chainBeltAmount"></ConveyorTableRow>
                    <ConveyorTableRow :label="$t('TRANSLATOR.TOTAL_LENGTH')" :value="lineInfo.chainBeltLength"></ConveyorTableRow>
                    <ConveyorTableRow :label="$t('TRANSLATOR.STOCK_LOCATION')" :value="lineInfo.chainBeltStockLocation" v-show="lineInfo.chainBeltStockLocation != ''"></ConveyorTableRow>
                    <ConveyorTableRow :label="$t('TRANSLATOR.NOTES')" :value="lineInfo.chainBeltNotes" v-show="lineInfo.chainBeltNotes != ''"></ConveyorTableRow>
                    <ConveyorTableRowStatus :label="$t('TRANSLATOR.STATUS')" :value="lineInfo.chainBeltStatus"></ConveyorTableRowStatus>
                    <!-- chainBeltImgUrl -->
                    <!-- <ConveyorTableRow :label="$t('ECOMMERCE.VIEW_PRODUCT')" :value="lineInfo.chainBeltCode" :href="'#/shop/'+lineInfo.chainBeltCategory+'/'+lineInfo.chainBeltCode"></ConveyorTableRow> -->
                    <tr>
                      <td width="30%" style="min-width: 100px">
                        <b-col md="12" style="max-width: 150px;">
                          <b-card-img
                            :src="lineInfo.chainBeltImgUrl"
                            class="rounded-0"
                          ></b-card-img>
                        </b-col>
                      </td>
                      <td width="70%" style="min-width: 110px">
          <div class="row" style="margin-right: 0px; margin-left: 0px;">
            <div class="col-6 col-md-4" v-if="lineInfo.chainBeltS1 !== ''">
                <div class="mb-8 d-flex flex-column">
                    <span class="text-dark font-weight-bold mb-4">{{lineInfo.chainBeltS1Label}}</span>
                    <span class="text-muted font-weight-bolder font-size-lg">{{lineInfo.chainBeltS1}}</span>
                </div>
            </div>
            <div class="col-6 col-md-4" v-if="lineInfo.chainBeltS2 !== ''">
                <div class="mb-8 d-flex flex-column">
                    <span class="text-dark font-weight-bold mb-4"> {{lineInfo.chainBeltS2Label}}</span>
                    <span class="text-muted font-weight-bolder font-size-lg"> {{lineInfo.chainBeltS2}} </span>
                </div>
            </div>
            <div class="col-6 col-md-4" v-if="lineInfo.chainBeltS3 !== ''">
                <div class="mb-8 d-flex flex-column">
                    <span class="text-dark font-weight-bold mb-4"> {{lineInfo.chainBeltS3Label}} </span>
                    <span class="text-muted font-weight-bolder font-size-lg"> {{lineInfo.chainBeltS3}} </span>
                </div>
            </div>
            <div class="col-6 col-md-4" v-if="lineInfo.chainBeltS4 !== ''">
                <div class="mb-8 d-flex flex-column">
                    <span class="text-dark font-weight-bold mb-4"> {{lineInfo.chainBeltS4Label}} </span>
                    <span class="text-muted font-weight-bolder font-size-lg"> {{lineInfo.chainBeltS4}} </span>
                </div>
            </div>
            <div class="col-6 col-md-4" v-if="lineInfo.chainBeltS5 !== ''">
                <div class="mb-8 d-flex flex-column">
                    <span class="text-dark font-weight-bold mb-4"> {{lineInfo.chainBeltS5Label}} </span>
                    <span class="text-muted font-weight-bolder font-size-lg"> {{lineInfo.chainBeltS5}} </span>
                </div>
            </div>
            <div class="col-6 col-md-4" v-if="lineInfo.chainBeltS6 !== ''">
                <div class="mb-8 d-flex flex-column">
                    <span class="text-dark font-weight-bold mb-4"> {{lineInfo.chainBeltS6Label}} </span>
                    <span class="text-muted font-weight-bolder font-size-lg"> {{lineInfo.chainBeltS6}} </span>
                </div>
            </div>
        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="card card-custom gutter-b" ref="DriveSprockets" v-if="lineInfo.driveSprocketCode != ''">
            <div class="card-header border-0 py-5">
              <h3 class="card-title align-items-start flex-column">
                <span class="card-label font-weight-bolder text-dark">{{ $t('PARTS.DriveSprocket') }}</span>
              </h3>
              <div class="card-toolbar">
                <!-- <b-alert
                v-if="alert5.show"
                :show="alert5.dismissCountDown"
                dismissible
                :variant="alert5.variant"
                @dismissed="dismissAlert2(5)"
                @dismiss-count-down="countDownChanged2(5, $event)"
                class="mr-4"
                >
                  Product added to cart
                </b-alert>
                <div class="text-right">
                  <span @click="RemoveQty(4)" class="btn btn-xs btn-light-success btn-icon mr-2">
                    <i class="ki ki-minus icon-xs"></i>
                  </span>
                  {{ this.PartsInfo[4].Quantity }} x {{ this.lineInfo.driveSprocketMinOrderQty }}
                  <span @click="AddQty(4)" class="btn btn-xs btn-light-success btn-icon mr-4">
                    <i class="ki ki-plus icon-xs"></i>
                  </span>
                  <button @click="AddToCart(4),showAlert2(5)" class="btn btn-primary font-weight-bolder font-size-sm">
                    <span class="svg-icon svg-icon-md svg-icon-white">
                      <inline-svg src="media/svg/icons/Shopping/Cart2.svg" />
                    </span>
                    {{ $t('ECOMMERCE.ADDTOCART') }}
                </button>
                </div> -->
                <div class="dropdown dropdown-inline ml-4">
                  <ChangeStatusPart @statusChange="handleStatusChange" :lineNumber="lineInfo.lineNumber"
                    :companyId="lineInfo.companyId" :conveyorNumber="lineInfo.conveyorNumber"
                    sparePart="[Drive sprocket status]" :currentStatus="lineInfo.driveSprocketStatus" :userId="userId"
                    :userEmail="userEmail" :userName="userName">
                  </ChangeStatusPart>
                </div>
              </div>
            </div>
            <div class="card-body py-0">
              <div class="table-responsive">
                <table class="table table-head-custom table-vertical-center striped" id="kt_advance_table_widget_4">
                  <tbody>
                    <ConveyorTableRow :label="$t('TRANSLATOR.NAME')" :value="lineInfo.driveSprocketName"></ConveyorTableRow>
                    <ConveyorTableRow label="Code" :value="lineInfo.driveSprocketCode" v-show="lineInfo.driveSprocketCode != '' && lineInfo.driveSprocketCodeExt === ''"></ConveyorTableRow>
                    <ConveyorTableRow label="Extern Code" :value="lineInfo.driveSprocketCodeExt" v-show="lineInfo.driveSprocketCodeExt != ''"></ConveyorTableRow>
                    <ConveyorTableRow :label="$t('TRANSLATOR.AMOUNT')" :value="lineInfo.driveSprocketAmount"></ConveyorTableRow>
                    <ConveyorTableRow :label="$t('TRANSLATOR.NOTES')" :value="lineInfo.driveSprocketNotes" v-show="lineInfo.driveSprocketNotes != ''"></ConveyorTableRow>
                    <ConveyorTableRowStatus :label="$t('TRANSLATOR.STATUS')" :value="lineInfo.driveSprocketStatus"></ConveyorTableRowStatus>
                    <ConveyorTableRow :label="$t('TRANSLATOR.STOCK_LOCATION')" :value="lineInfo.driveSprocketStockLocation" v-show="lineInfo.driveSprocketStockLocation != ''"></ConveyorTableRow>
                    <!-- <ConveyorTableRow :label="$t('ECOMMERCE.VIEW_PRODUCT')" :value="lineInfo.driveSprocketCode" :href="'#/shop/'+lineInfo.driveSprocketCategory+'/'+lineInfo.driveSprocketCode"></ConveyorTableRow> -->
                     
                    <tr>
                      <td width="30%" style="min-width: 100px">
                        <b-col md="12" style="max-width: 150px;">
                          <b-card-img
                            :src="lineInfo.driveSprocketImgUrl"
                            class="rounded-0"
                          ></b-card-img>
                        </b-col>
                      </td>
                      <td width="70%" style="min-width: 110px">
          <div class="row" style="margin-right: 0px; margin-left: 0px;">
            <div class="col-6 col-md-4" v-if="lineInfo.driveSprocketS1 !== ''">
                <div class="mb-8 d-flex flex-column">
                    <span class="text-dark font-weight-bold mb-4">{{lineInfo.driveSprocketS1Label}}</span>
                    <span class="text-muted font-weight-bolder font-size-lg">{{lineInfo.driveSprocketS1}}</span>
                </div>
            </div>
            <div class="col-6 col-md-4" v-if="lineInfo.driveSprocketS2 !== ''">
                <div class="mb-8 d-flex flex-column">
                    <span class="text-dark font-weight-bold mb-4"> {{lineInfo.driveSprocketS2Label}}</span>
                    <span class="text-muted font-weight-bolder font-size-lg"> {{lineInfo.driveSprocketS2}} </span>
                </div>
            </div>
            <div class="col-6 col-md-4" v-if="lineInfo.driveSprocketS3 !== ''">
                <div class="mb-8 d-flex flex-column">
                    <span class="text-dark font-weight-bold mb-4"> {{lineInfo.driveSprocketS3Label}} </span>
                    <span class="text-muted font-weight-bolder font-size-lg"> {{lineInfo.driveSprocketS3}} </span>
                </div>
            </div>
            <div class="col-6 col-md-4" v-if="lineInfo.driveSprocketS4 !== ''">
                <div class="mb-8 d-flex flex-column">
                    <span class="text-dark font-weight-bold mb-4"> {{lineInfo.driveSprocketS4Label}} </span>
                    <span class="text-muted font-weight-bolder font-size-lg"> {{lineInfo.driveSprocketS4}} </span>
                </div>
            </div>
            <div class="col-6 col-md-4" v-if="lineInfo.driveSprocketS5 !== ''">
                <div class="mb-8 d-flex flex-column">
                    <span class="text-dark font-weight-bold mb-4"> {{lineInfo.driveSprocketS5Label}} </span>
                    <span class="text-muted font-weight-bolder font-size-lg"> {{lineInfo.driveSprocketS5}} </span>
                </div>
            </div>
            <div class="col-6 col-md-4" v-if="lineInfo.driveSprocketS6 !== ''">
                <div class="mb-8 d-flex flex-column">
                    <span class="text-dark font-weight-bold mb-4"> {{lineInfo.driveSprocketS6Label}} </span>
                    <span class="text-muted font-weight-bolder font-size-lg"> {{lineInfo.driveSprocketS6}} </span>
                </div>
            </div>
        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="card card-custom gutter-b" ref="IdlerSprockets" v-if="lineInfo.idlerSprocketCode != ''">
            <div class="card-header border-0 py-5">
              <h3 class="card-title align-items-start flex-column">
                <span class="card-label font-weight-bolder text-dark">{{ $t('PARTS.IdlerSprocket') }}</span>
              </h3>
              <div class="card-toolbar">
                <!-- <b-alert
                v-if="alert6.show"
                :show="alert6.dismissCountDown"
                dismissible
                :variant="alert6.variant"
                @dismissed="dismissAlert2(6)"
                @dismiss-count-down="countDownChanged2(6, $event)"
                class="mr-4"
                >
                  Product added to cart
                </b-alert>
                <div class="text-right">
                  <span @click="RemoveQty(5)" class="btn btn-xs btn-light-success btn-icon mr-2">
                    <i class="ki ki-minus icon-xs"></i>
                  </span>
                  {{ this.PartsInfo[5].Quantity }} x {{ this.lineInfo.idlerSprocketMinOrderQty }}
                  <span @click="AddQty(5)" class="btn btn-xs btn-light-success btn-icon mr-4">
                    <i class="ki ki-plus icon-xs"></i>
                  </span>
                  <button @click="AddToCart(5),showAlert2(6)" class="btn btn-primary font-weight-bolder font-size-sm">
                    <span class="svg-icon svg-icon-md svg-icon-white">
                      <inline-svg src="media/svg/icons/Shopping/Cart2.svg" />
                    </span>
                    {{ $t('ECOMMERCE.ADDTOCART') }}
                </button>
                </div> -->
                <div class="dropdown dropdown-inline ml-4">
                  <ChangeStatusPart @statusChange="handleStatusChange" :lineNumber="lineInfo.lineNumber"
                    :companyId="lineInfo.companyId" :conveyorNumber="lineInfo.conveyorNumber"
                    sparePart="[Idler sprocket status]" :currentStatus="lineInfo.idlerSprocketStatus" :userId="userId"
                    :userEmail="userEmail" :userName="userName">
                  </ChangeStatusPart>
                </div>
              </div>
            </div>
            <div class="card-body py-0">
              <div class="table-responsive">
                <table class="table table-head-custom table-vertical-center striped" id="kt_advance_table_widget_4">
                  <tbody>
                    <ConveyorTableRow :label="$t('TRANSLATOR.NAME')" :value="lineInfo.idlerSprocketName"></ConveyorTableRow>
                    <ConveyorTableRow label="Code" :value="lineInfo.idlerSprocketCode" v-show="lineInfo.idlerSprocketCode != '' && lineInfo.idlerSprocketCodeExt === ''"></ConveyorTableRow>
                    <ConveyorTableRow label="Extern Code" :value="lineInfo.idlerSprocketCodeExt" v-show="lineInfo.idlerSprocketCodeExt != ''"></ConveyorTableRow>
                    <ConveyorTableRow :label="$t('TRANSLATOR.AMOUNT')" :value="lineInfo.idlerSprocketAmount"
                      v-show="lineInfo.idlerSprocketAmount > 0"></ConveyorTableRow>
                    <ConveyorTableRow :label="$t('TRANSLATOR.STOCK_LOCATION')" :value="lineInfo.idlerSprocketStockLocation" v-show="lineInfo.idlerSprocketStockLocation != ''"></ConveyorTableRow>
                    <ConveyorTableRow :label="$t('TRANSLATOR.NOTES')" :value="lineInfo.idlerSprocketNotes" v-show="lineInfo.idlerSprocketNotes != ''"></ConveyorTableRow>
                    <ConveyorTableRowStatus :label="$t('TRANSLATOR.STATUS')" :value="lineInfo.idlerSprocketStatus"></ConveyorTableRowStatus>
                    <!-- idlerSprocketImgUrl -->
                    <!-- <ConveyorTableRow :label="$t('ECOMMERCE.VIEW_PRODUCT')" :value="lineInfo.idlerSprocketCode" :href="'#/shop/'+lineInfo.idlerSprocketCategory+'/'+lineInfo.idlerSprocketCode"></ConveyorTableRow> -->
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="card card-custom gutter-b" ref="Curves" v-show="lineInfo.curveType != '' && lineInfo.curveAmount > 0">
            <div class="card-header border-0 py-5">
              <h3 class="card-title align-items-start flex-column">
                <span class="card-label font-weight-bolder text-dark">{{ $t('PARTS.Curve') }}</span>
              </h3>
              <div class="card-toolbar">
                <!-- <b-alert
                v-if="alert7.show"
                :show="alert7.dismissCountDown"
                dismissible
                :variant="alert7.variant"
                @dismissed="dismissAlert2(7)"
                @dismiss-count-down="countDownChanged2(7, $event)"
                class="mr-4"
                >
                  Product added to cart
                </b-alert>
                <div class="text-right">
                  <span @click="RemoveQty(6)" class="btn btn-xs btn-light-success btn-icon mr-2">
                    <i class="ki ki-minus icon-xs"></i>
                  </span>
                  {{ this.PartsInfo[6].Quantity }} x {{ this.lineInfo.motorMinOrderQty }}
                  <span @click="AddQty(6),showAlert2(7)" class="btn btn-xs btn-light-success btn-icon mr-4">
                    <i class="ki ki-plus icon-xs"></i>
                  </span>
                  <button @click="AddToCart(6)" class="btn btn-primary font-weight-bolder font-size-sm">
                    <span class="svg-icon svg-icon-md svg-icon-white">
                      <inline-svg src="media/svg/icons/Shopping/Cart2.svg" />
                    </span>
                    {{ $t('ECOMMERCE.ADDTOCART') }}
                </button>
                </div> -->
                <div class="dropdown dropdown-inline ml-4">
                  <ChangeStatusPart @statusChange="handleStatusChange" :lineNumber="lineInfo.lineNumber"
                    :companyId="lineInfo.companyId" :conveyorNumber="lineInfo.conveyorNumber" sparePart="[Curve status]"
                    :currentStatus="lineInfo.curveStatus" :userId="userId" :userEmail="userEmail" :userName="userName">
                  </ChangeStatusPart>
                </div>
              </div>
            </div>
            <div class="card-body py-0">
              <div class="table-responsive">
                <table class="table table-head-custom table-vertical-center striped" id="kt_advance_table_widget_4">
                  <tbody>
                    <ConveyorTableRow label="Code" :value="lineInfo.curveType" v-show="lineInfo.curveType != ''">
                    </ConveyorTableRow>
                    <ConveyorTableRow :label="$t('TRANSLATOR.AMOUNT')" :value="lineInfo.curveAmount" v-show="lineInfo.curveAmount > 0">
                    </ConveyorTableRow>
                    <ConveyorTableRow :label="$t('TRANSLATOR.NOTES')" :value="lineInfo.curveNotes" v-show="lineInfo.curveNotes != ''"></ConveyorTableRow>
                    <ConveyorTableRowStatus :label="$t('TRANSLATOR.STATUS')" :value="lineInfo.curveStatus" v-show="lineInfo.curveStatus != ''"></ConveyorTableRowStatus>
                      <!-- <ConveyorTableRow :label="$t('ECOMMERCE.VIEW_PRODUCT')" :value="lineInfo.driveBearingCode" :href="'#/shop/'+lineInfo.curveCategory+'/'+lineInfo.chainBeltCode"></ConveyorTableRow> -->
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="card card-custom gutter-b" ref="Wearstrip" v-show="lineInfo.wearstripName != '' && lineInfo.wearstripStatus != ''">
            <div class="card-header border-0 py-5">
              <h3 class="card-title align-items-start flex-column">
                <span class="card-label font-weight-bolder text-dark">{{ $t('PARTS.Wearstrip') }}</span>
              </h3>
              <div class="card-toolbar">
                <!-- <b-alert
                v-if="alert8.show"
                :show="alert8.dismissCountDown"
                dismissible
                :variant="alert8.variant"
                @dismissed="dismissAlert2(8)"
                @dismiss-count-down="countDownChanged2(8, $event)"
                class="mr-4"
                >
                  Product added to cart
                </b-alert>
                <div class="text-right">
                  <span @click="RemoveQty(7)" class="btn btn-xs btn-light-success btn-icon mr-2">
                    <i class="ki ki-minus icon-xs"></i>
                  </span>
                  {{ this.PartsInfo[7].Quantity }} x {{ this.lineInfo.wearstripMinOrderQty }}
                  <span @click="AddQty(7)" class="btn btn-xs btn-light-success btn-icon mr-4">
                    <i class="ki ki-plus icon-xs"></i>
                  </span>
                  <button @click="AddToCart(7),showAlert2(8)" class="btn btn-primary font-weight-bolder font-size-sm">
                    <span class="svg-icon svg-icon-md svg-icon-white">
                      <inline-svg src="media/svg/icons/Shopping/Cart2.svg" />
                    </span>
                    {{ $t('ECOMMERCE.ADDTOCART') }}
                </button>
                </div> -->
                <div class="dropdown dropdown-inline ml-4">
                  <ChangeStatusPart @statusChange="handleStatusChange" :lineNumber="lineInfo.lineNumber"
                    :companyId="lineInfo.companyId" :conveyorNumber="lineInfo.conveyorNumber"
                    sparePart="[Wearstrip status]" :currentStatus="lineInfo.wearstripStatus" :userId="userId"
                    :userEmail="userEmail" :userName="userName">
                  </ChangeStatusPart>
                </div>
              </div>
            </div>
            <div class="card-body py-0">
              <div class="table-responsive">
                <table class="table table-head-custom table-vertical-center striped" id="kt_advance_table_widget_4">
                  <tbody>
                    <ConveyorTableRow :label="$t('TRANSLATOR.NAME')" :value="lineInfo.wearstripName" v-show="lineInfo.wearstripName != ''"></ConveyorTableRow>
                    <ConveyorTableRow label="Code" :value="lineInfo.wearstripCode" v-show="lineInfo.wearstripCode != ''"></ConveyorTableRow>
                    <ConveyorTableRow label="Extern Code" :value="lineInfo.wearstripCodeExt" v-show="lineInfo.wearstripCodeExt != ''"></ConveyorTableRow>
                    <ConveyorTableRow :label="$t('TRANSLATOR.STOCK_LOCATION')" :value="lineInfo.wearstripStockLocation" v-show="lineInfo.wearstripStockLocation != ''"></ConveyorTableRow>
                    <ConveyorTableRow :label="$t('TRANSLATOR.NOTES')" :value="lineInfo.wearstripNotes" v-show="lineInfo.wearstripNotes != ''"></ConveyorTableRow>
                    <ConveyorTableRow label="Length" :value="lineInfo.wearstripLength" v-show="lineInfo.wearstripLength != ''"></ConveyorTableRow>
                    <ConveyorTableRow label="Brand" :value="lineInfo.wearstripBrand" v-show="lineInfo.wearstripBrand != ''"></ConveyorTableRow>
                    <ConveyorTableRow :label="$t('TRANSLATOR.SERIES')" :value="lineInfo.wearstripSeries"
                      v-show="lineInfo.wearstripSeries != ''"></ConveyorTableRow>
                    <ConveyorTableRow :label="$t('TRANSLATOR.WIDTH')" :value="lineInfo.wearstripWidth"
                      v-show="lineInfo.wearstripWidth != ''"></ConveyorTableRow>
                    <ConveyorTableRow :label="$t('TRANSLATOR.HIGH')" :value="lineInfo.wearstripHigh"
                      v-show="lineInfo.wearstripHigh != ''"></ConveyorTableRow>
                    <ConveyorTableRow label="Tickness" :value="lineInfo.wearstripThickness"
                      v-show="lineInfo.wearstripThickness != ''"></ConveyorTableRow>
                    <ConveyorTableRow :label="$t('TRANSLATOR.COLOR')" :value="lineInfo.wearstripColor"
                      v-show="lineInfo.wearstripColor != ''"></ConveyorTableRow>
                    <ConveyorTableRowStatus :label="$t('TRANSLATOR.STATUS')" :value="lineInfo.wearstripStatus" v-show="lineInfo.wearstripStatus != ''"></ConveyorTableRowStatus>
                    <!-- wearstripImgUrl -->
                    <!-- <ConveyorTableRow :label="$t('ECOMMERCE.VIEW_PRODUCT')" :value="lineInfo.wearstripCode" :href="'#/shop/'+lineInfo.wearstripCategory+'/'+lineInfo.wearstripCode"></ConveyorTableRow> -->
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="card card-custom gutter-b" ref="Rollers" v-show="lineInfo.rollerName != '' && lineInfo.rollerCode != '' && lineInfo.rollerSeries != ''">
            <div class="card-header border-0 py-5">
              <h3 class="card-title align-items-start flex-column">
                <span class="card-label font-weight-bolder text-dark">{{ $t('PARTS.Roller') }}</span>
              </h3>
              <div class="card-toolbar">
                <!-- <b-alert
                v-if="alert9.show"
                :show="alert9.dismissCountDown"
                dismissible
                :variant="alert9.variant"
                @dismissed="dismissAlert2(9)"
                @dismiss-count-down="countDownChanged2(9, $event)"
                class="mr-4"
                >
                  Product added to cart
                </b-alert>
                <div class="text-right">
                  <span @click="RemoveQty(8)" class="btn btn-xs btn-light-success btn-icon mr-2">
                    <i class="ki ki-minus icon-xs"></i>
                  </span>
                  {{ this.PartsInfo[8].Quantity }} x {{ this.lineInfo.rollerMinOrderQty }}
                  <span @click="AddQty(8)" class="btn btn-xs btn-light-success btn-icon mr-4">
                    <i class="ki ki-plus icon-xs"></i>
                  </span>
                  <button @click="AddToCart(8),showAlert2(9)" class="btn btn-primary font-weight-bolder font-size-sm">
                    <span class="svg-icon svg-icon-md svg-icon-white">
                      <inline-svg src="media/svg/icons/Shopping/Cart2.svg" />
                    </span>
                    {{ $t('ECOMMERCE.ADDTOCART') }}
                </button>
                </div> -->
                <div class="dropdown dropdown-inline ml-4">
                  <ChangeStatusPart @statusChange="handleStatusChange" :lineNumber="lineInfo.lineNumber"
                    :companyId="lineInfo.companyId" :conveyorNumber="lineInfo.conveyorNumber"
                    sparePart="[Roller status]" :currentStatus="lineInfo.rollerStatus" :userId="userId"
                    :userEmail="userEmail" :userName="userName">
                  </ChangeStatusPart>
                 
                </div>
              </div>
            </div>
            <div class="card-body py-0">
              <div class="table-responsive">
                <table class="table table-head-custom table-vertical-center striped" id="kt_advance_table_widget_4">
                  <tbody>
                    <ConveyorTableRow :label="$t('TRANSLATOR.NAME')" :value="lineInfo.rollerName" v-show="lineInfo.rollerName != ''">
                    </ConveyorTableRow>
                    <ConveyorTableRow label="Code" :value="lineInfo.rollerCode" v-show="lineInfo.rollerCodeExt === ''"></ConveyorTableRow>
                    <ConveyorTableRow label="Extern Code" :value="lineInfo.rollerCodeExt" v-show="lineInfo.rollerCodeExt != ''"></ConveyorTableRow>
                    <ConveyorTableRow :label="$t('TRANSLATOR.STOCK_LOCATION')" :value="lineInfo.rollerStockLocation" v-show="lineInfo.rollerStockLocation != ''"></ConveyorTableRow>
                    <!-- <ConveyorTableRow label="Length" :value="lineInfo.rollerLength"></ConveyorTableRow> -->
                    <ConveyorTableRow :label="$t('TRANSLATOR.NOTES')" :value="lineInfo.rollerNotes" v-show="lineInfo.rollerNotes != ''"></ConveyorTableRow>
                    <ConveyorTableRowStatus :label="$t('TRANSLATOR.STATUS')" :value="lineInfo.rollerStatus"></ConveyorTableRowStatus>
                    <ConveyorTableRow :label="$t('TRANSLATOR.SERIES')" :value="lineInfo.rollerSeries" v-show="lineInfo.rollerSeries != ''"></ConveyorTableRow>
                    <ConveyorTableRow :label="$t('TRANSLATOR.WIDTH')" :value="lineInfo.rollerWidth" v-show="lineInfo.rollerWidth != ''"></ConveyorTableRow>
                    <ConveyorTableRow :label="$t('TRANSLATOR.HIGH')" :value="lineInfo.rollerShaftdiameter" v-show="lineInfo.rollerShaftdiameter != ''"></ConveyorTableRow>
                    <ConveyorTableRow :label="$t('TRANSLATOR.DIAMETER')" :value="lineInfo.rollerBoreDiameter" v-show="lineInfo.rollerBoreDiameter != ''"></ConveyorTableRow>
                    <ConveyorTableRow :label="$t('TRANSLATOR.OUTSIDE_DIAMETER')" :value="lineInfo.rollerOutsideDiameter" v-show="
                      lineInfo.rollerOutsideDiameter != null &&
                      lineInfo.rollerOutsideDiameter != ''
                    "></ConveyorTableRow>
                    <ConveyorTableRow :label="$t('TRANSLATOR.COLOR')" :value="lineInfo.rollerMaterial" v-show="lineInfo.rollerMaterial != ''"></ConveyorTableRow>
                    <!-- rollerImgUrl -->
                    <!-- <ConveyorTableRow :label="$t('ECOMMERCE.VIEW_PRODUCT')" :value="lineInfo.rollerCode" :href="'#/shop/'+lineInfo.rollerCategory+'/'+lineInfo.rollerCode"></ConveyorTableRow> -->
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="card card-custom gutter-b" ref="Components" v-show="lineInfo.componentsName != '' || lineInfo.componentsAmount > 0 || lineInfo.componentsCode != ''">
            <div class="card-header border-0 py-5">
              <h3 class="card-title align-items-start flex-column">
                <span class="card-label font-weight-bolder text-dark">{{ $t('PARTS.Components') }}</span>
              </h3>
              <div class="card-toolbar">
                <!-- <b-alert
                v-if="alert10.show"
                :show="alert10.dismissCountDown"
                dismissible
                :variant="alert10.variant"
                @dismissed="dismissAlert2(10)"
                @dismiss-count-down="countDownChanged2(10, $event)"
                class="mr-4"
                >
                  Product added to cart
                </b-alert>
                <div class="text-right">
                  <span @click="RemoveQty(9)" class="btn btn-xs btn-light-success btn-icon mr-2">
                    <i class="ki ki-minus icon-xs"></i>
                  </span>
                  {{ this.PartsInfo[9].Quantity }} x {{ this.lineInfo.componentsMinOrderQty }}
                  <span @click="AddQty(9)" class="btn btn-xs btn-light-success btn-icon mr-4">
                    <i class="ki ki-plus icon-xs"></i>
                  </span>
                  <button @click="AddToCart(9),showAlert2(10)" class="btn btn-primary font-weight-bolder font-size-sm">
                    <span class="svg-icon svg-icon-md svg-icon-white">
                      <inline-svg src="media/svg/icons/Shopping/Cart2.svg" />
                    </span>
                    {{ $t('ECOMMERCE.ADDTOCART') }}
                </button>
                </div> -->
                <div class="dropdown dropdown-inline ml-4">
                  <ChangeStatusPart @statusChange="handleStatusChange" :lineNumber="lineInfo.lineNumber"
                    :companyId="lineInfo.companyId" :conveyorNumber="lineInfo.conveyorNumber"
                    sparePart="[Components status]" :currentStatus="lineInfo.componentsStatus" :userId="userId"
                    :userEmail="userEmail" :userName="userName">
                  </ChangeStatusPart>
                </div>
              </div>
            </div>
            <div class="card-body py-0">
              <div class="table-responsive">
                <table class="table table-head-custom table-vertical-center striped" id="kt_advance_table_widget_4">
                  <tbody>
                    <ConveyorTableRow :label="$t('TRANSLATOR.NAME')" :value="lineInfo.componentsName" v-show="lineInfo.componentsName != ''"></ConveyorTableRow>
                    <ConveyorTableRow label="Code" :value="lineInfo.componentsCode" v-show="lineInfo.componentsCode != ''"></ConveyorTableRow>
                    <ConveyorTableRow label="Extern Code" :value="lineInfo.componentsCodeExt" v-show="lineInfo.componentsCodeExt != ''"></ConveyorTableRow>
                    <ConveyorTableRow :label="$t('TRANSLATOR.AMOUNT')" :value="lineInfo.componentsAmount" v-show="lineInfo.componentsAmount > 0"></ConveyorTableRow>
                    <ConveyorTableRow :label="$t('TRANSLATOR.STOCK_LOCATION')" :value="lineInfo.componentsStockLocation" v-show="lineInfo.componentsStockLocation != ''"></ConveyorTableRow>
                    <ConveyorTableRow :label="$t('TRANSLATOR.NOTES')" :value="lineInfo.componentsNotes" v-show="lineInfo.componentsNotes != ''"></ConveyorTableRow>
                    <ConveyorTableRowStatus :label="$t('TRANSLATOR.STATUS')" :value="lineInfo.componentsStatus" v-show="lineInfo.componentsStatus != ''"></ConveyorTableRowStatus>
                    <ConveyorTableRow :label="$t('TRANSLATOR.SERIES')" :value="lineInfo.componentsSeries" v-show="lineInfo.componentsSeries != ''"></ConveyorTableRow>
                    <!-- componentsImgUrl -->
                      <!-- <ConveyorTableRow :label="$t('ECOMMERCE.VIEW_PRODUCT')" :value="lineInfo.componentsCode" :href="'#/shop/'+lineInfo.componentsCategory+'/'+lineInfo.componentsCode"></ConveyorTableRow> -->
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="card card-custom gutter-b" ref="Maintenance">
            <div class="card-header border-0 py-5">
              <h3 class="card-title align-items-start flex-column">
                <span class="card-label font-weight-bolder text-dark">{{ $t('TRANSLATOR.MAINTENANCE_HISTORY') }}</span>
              </h3>
            </div>
            <div class="card-body py-0">
              <HistoryTable v-bind:lineHistory="lineHistory" :lineId="lineId" :conveyorId="conveyorId"></HistoryTable>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <div>
      <b-modal id="modal-2" size="lg">
        <b-img fluid v-bind:src="backgroundImage" @error="backgroundImageLoadError" alt="Image Big"></b-img>
      </b-modal>
      <b-modal id="modal-pdf-viewer" :title="this.fullPdfurl" size="xl" scrollable>
        <b-row>
          <b-col md="6" class="text-left">
            <a class="btn btn-primary font-size-sm ml-3" @click="page--" :class="page < 2 ? ' disabled' : ''" v-if="pageCount > 1">
              <span class="svg-icon svg-icon-md svg-icon-white">
                <inline-svg src="media/svg/icons/Media/Backward.svg" />
            </span>{{ $t('TRANSLATOR.PREV') }}</a>
            <a class="btn btn-primary font-size-sm ml-3" @click="page++" :class="page >= pageCount ? ' disabled' : ''" v-if="pageCount > 1">
              <span class="svg-icon svg-icon-md svg-icon-white ">
                <inline-svg src="media/svg/icons/Media/Forward.svg" />
            </span>{{ $t('TRANSLATOR.NEXT') }}</a>
            <a :href="`media/upload/${this.fullPdfurl}`" target="_blank" class="btn btn-primary font-size-sm ml-3" v-b-tooltip.hover.top="$t('TRANSLATOR.MORE_PDF')">
              <span class="svg-icon svg-icon-md svg-icon-white">
                <inline-svg src="media/svg/icons/Design/ZoomPlus.svg" />
            </span>More</a>
          </b-col>
          <b-col md="6" class="text-right">
            {{currentPage}} / {{pageCount}}
          </b-col>
        </b-row>
        <pdf
          :src="`media/upload/${this.fullPdfurl}`"
          :page="page"
          @num-pages="pageCount = $event"
          @page-loaded="currentPage = $event"
          class="mt-3"
        ></pdf>
      </b-modal>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ConveyorTableRow from "@/view/pages/conveyor/ConveyorTableRow";
import ConveyorTableRowStatus from "@/view/pages/conveyor/ConveyorTableRowStatus";
import HistoryTable from "@/view/pages/conveyor/HistoryTable";
import Dropdown3 from "@/view/content/dropdown/Dropdown3.vue";
import ChangeStatusPart from "@/view/content/dropdown/ChangeStatusPart.vue";
import ConveyorCard from "@/view/pages/conveyor/ConveyorCard.vue";
import JwtService from "@/core/services/jwt.service";
import VueSimpleAlert from "vue-simple-alert";
Vue.use(VueSimpleAlert, { reverseButtons: true });
import pdf from 'vue-pdf';

const dataURItoBlob = (dataURI) => {
  const bytes = dataURI.split(',')[0].indexOf('base64') >= 0
    ? atob(dataURI.split(',')[1])
    : unescape(dataURI.split(',')[1]);
  const mime = dataURI.split(',')[0].split(':')[1].split(';')[0];
  const max = bytes.length;
  const ia = new Uint8Array(max);
  for (let i = 0; i < max; i += 1) ia[i] = bytes.charCodeAt(i);
  return new Blob([ia], { type: mime });
};

const resizeImage = ({ file, maxSize }) => {
  const reader = new FileReader();
  const image = new Image();
  const canvas = document.createElement('canvas');
 
  const resize = () => {
    let { width, height } = image;

    if (width > height) {
      if (width > maxSize) {
        height *= maxSize / width;
        width = maxSize;
      }
    } else if (height > maxSize) {
      width *= maxSize / height;
      height = maxSize;
    }

    canvas.width = width;
    canvas.height = height;
    canvas.getContext('2d').drawImage(image, 0, 0, width, height);

    const dataUrl = canvas.toDataURL('image/jpeg');
    return dataURItoBlob(dataUrl);
  };

  return new Promise((ok, no) => {
    if (!file.type.match(/image.*/)) {
      no(new Error('Not an image'));
      return;
    }

    reader.onload = (readerEvent) => {
      image.onload = () => ok(resize());
      image.src = readerEvent.target.result;
    };
    reader.readAsDataURL(file);
  });
};

// import VueBasicAlert from 'vue-basic-alert'
export default {
  name: "Header",
  props: {
    lineId: String,
    breadcrumbs: Array,
    // conveyorId: String
    conveyorId: String,
    // currentStatus: String
  },
  data() {
    return {
      lineInfo: {},
      lineHistory: {},
      selected: "",
      UpdatedData: "",
      name: "Vue.js",
      newstatus: null,
      headerfile: null,
      url: null,
      isHideQuote: true,
      // Get Quote
      QuoteSubject: null,
      QuoteMessage: null,
      selectedParts: [],
      isImageSize: false,
      PartsInfo:[],
      Parts: [
        { id: "1", PartsLabel: "Motor" },
        { id: "2", PartsLabel: "Drive Bearing" },
        { id: "3", PartsLabel: "Idler Bearing" },
        { id: "4", PartsLabel: "Chain & Belt" },
        { id: "5", PartsLabel: "Drive Sprocket" },
        { id: "6", PartsLabel: "Idler Sprocket" },
        { id: "7", PartsLabel: "Curve" },
        { id: "8", PartsLabel: "Wearstrip" },
        { id: "9", PartsLabel: "Roller" },
        { id: "10", PartsLabel: "Components" },
      ],
      submitted: false,
      QuoteSubmitted: false,
      sparePart: null,
      apiConveyor: null,
      userId: JwtService.authorizeToken().id,
      userName: JwtService.authorizeToken().name,
      userEmail: JwtService.authorizeToken().emailaddress,
      companyId: JwtService.authorizeToken().companyId,
      toSent: "maxim.vangammeren@max-line.nl",
      isAdmin: JwtService.authorizeToken().isAdmin,
      dismissSecs: 5,
      dismissCountDown: 0,
      dismissCountDownGetQuote: 0,
      alert1: {
        show: false,
        dismissSecs: 5,
        dismissCountDown: 0,
        variant: 'success',
      },
      alert2: {
        show: false,
        dismissSecs: 5,
        dismissCountDown: 0,
        variant: 'success',
      },
      alert3: {
        show: false,
        dismissSecs: 5,
        dismissCountDown: 0,
        variant: 'success',
      },
      alert4: {
        show: false,
        dismissSecs: 5,
        dismissCountDown: 0,
        variant: 'success',
      },alert5: {
        show: false,
        dismissSecs: 5,
        dismissCountDown: 0,
        variant: 'success',
      },
      alert6: {
        show: false,
        dismissSecs: 5,
        dismissCountDown: 0,
        variant: 'success',
      },
      alert7: {
        show: false,
        dismissSecs: 5,
        dismissCountDown: 0,
        variant: 'success',
      },
      alert8: {
        show: false,
        dismissSecs: 5,
        dismissCountDown: 0,
        variant: 'success',
      },
      alert9: {
        show: false,
        dismissSecs: 5,
        dismissCountDown: 0,
        variant: 'success',
      },
      alert10: {
        show: false,
        dismissSecs: 5,
        dismissCountDown: 0,
        variant: 'success',
      },
      Quantity: 1,
      minOrderQty: 1,
      productAdded: false,
      // UPLOAD PDF
      submittedPdf: false,
      headerpdffile: null,
      isPdfSize: false,
      pdfurl: null,
      fullPdfurl: null,
      pdf: false,
      responseData: null,
      responseStatus: null,
      responseText: null,
      // END UPLOAD PDF
			currentPage: 0,
			pageCount: 0,
      page: 1,
    };
  },
  components: {
    ConveyorTableRow,
    ConveyorTableRowStatus,
    HistoryTable,
    ConveyorCard,
    Dropdown3,
    ChangeStatusPart,
    pdf,
  },
  computed: {
    backgroundImage() {
      return "https://app.max-lineconnected.com/media/upload/" + this.companyId + "/" + this.lineInfo.lineNumber + "/" + this.lineInfo.conveyorNumber + "/HeaderImage.jpg";
    },
  },
  methods: {
    onFileChange(e) {
      const file = e.target.files[0];
      this.url = URL.createObjectURL(file);
    },
    backgroundImageLoadError (event) {
      event.target.src = "https://app.max-lineconnected.com/media/upload/Upload_Image.jpg";
    },
    reset: function() {
      this.headerfile = null;
    },
    handleRouteChange() { 
    },
    // submit form handler
    submit: function () {
      this.submitted = true;
    },
    handleStatusChange() {
      this.fetchLineData();
      this.fetchLineHistory();
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
    countDownChanged2(alertNumber, dismissCountDown) {
      this[`alert${alertNumber}`].dismissCountDown = dismissCountDown;
    },
    showAlert2(alertNumber) {
      this[`alert${alertNumber}`].dismissCountDown = this[`alert${alertNumber}`].dismissSecs;
      this[`alert${alertNumber}`].show = true;
    },
    dismissAlert2(alertNumber) {
      this[`alert${alertNumber}`].show = false;
      // Additional logic for alert dismissal as needed
    },
    goToHome(type) {
      if (this.isHideQuote == false) {
        this.isHideQuote = !this.isHideQuote;
      }
      if(type != ''){
      if (type == "next" && this.conveyorId < this.lineInfo.maxConveyorNumber) {
        this.conveyorId++;
      } else if (type == "prev" && this.conveyorId > 1){
        this.conveyorId--;
      }
      // this.conveyorId = this.conveyorId;
      this.fullPdfurl = null;

      // Get new data
      axios
        .get("line/" + this.lineId + "/conveyor/" + this.conveyorId)
        .then((response) => {
          this.lineInfo = response.data;
          this.UpdatedData = response.data.updated;
          this.fetchLineHistory();
          this.fetchPdf();
        })
        .catch((err) => {
          throw err;
        });
      // Empty variables
      this.headerfile = null;
      this.headerpdffile = null;
      this.url = null;
      this.pdfurl = null;
      this.headerimage = true;

      // Update BREADCRUMB
      this.$store.dispatch(SET_BREADCRUMB, [
        {
          title: `Home > Line ${this.lineId} > Conveyor ${this.conveyorId}`,
          route: `/line/${this.lineId}/`,
        },
      ]);
      
      // Update URL in browser
      this.$router.push(
        "/line/" + this.lineId + "/conveyor/" + this.conveyorId
      );
      
      // console.log(this.conveyorId);
      // var url = window.location.href;
      // const myArray = url.split("/");
      // let lastElement = myArray[myArray.length - 1];
      // let isConveyorPage = myArray[myArray.length - 2] === 'conveyor';
      // // this.conveyorId = lastElement;
      // console.log(myArray);
      // console.log(lastElement);
      // console.log(isConveyorPage);
      }
    },

    getStatusClass: (status) => {
      switch (status) {
        case "red":
          return "danger";
        case "orange":
          return "warning";
        case "green":
          return "success";
      }
    },
    goto(refName) {
      var element = this.$refs[refName];
      // console.log(element);
      element.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
    },
    fetchPdf() {
    axios
      .get("/line/" + this.lineId + "/GetPdf-" + this.conveyorId)
      .then((response) => {
        this.fullPdfurl = response.data;
      })
      .catch((err) => {
        throw err;
      });
    },
    fetchLineData() {
      axios
        .get("line/" + this.lineId + "/conveyor/" + this.conveyorId)
        .then((response) => {
          this.lineInfo = response.data;
          this.UpdatedData = response.data.updated;
          this.AddPartsInfo();
          // this.fetchPdf();
        })
        .catch((err) => {
          throw err;
        });
    },
    fetchLineHistory() {
      axios
        .get(
          "line/" + this.lineId + "/conveyor/" + this.conveyorId + "/history"
        )
        .then((response) => {
          this.lineHistory = response.data;
        })
        .catch((err) => {
          throw err;
        });
    },

    InsertInspect() {
      axios
        .post("line/Insertinspect", {
          CompanyId: this.companyId,
          LineNumber: this.lineInfo.lineNumber,
          ConveyorNumber: this.lineInfo.conveyorNumber,
          UserId: this.userId,
          Note: "inspected to Survey",
        })
        .then(() => {
          axios
            .get("line/" + this.lineId + "/conveyor/" + this.conveyorId)
            .then((response) => {
              this.lineInfo = response.data;
              this.UpdatedData = response.data.updated;
              this.fetchLineHistory();
              // console.log(this.lineInfo.driveBearingName);
            })
            .catch((err) => {
              throw err;
            });
        })
        .catch((err) => {
          throw err;
        });
    },
    submitGetQuote: function () {
      axios
        .post("line/sendQuote", {
          CompanyId: this.companyId,
          LineNumber: this.lineNumber,
          ConveyorNumber: this.conveyorNumber,
          UserEmail: this.userEmail,
          QuoteSubject: this.QuoteSubject,
          QuoteMessage: this.QuoteMessageHtml,
          ToMail: this.toSent,
        })
        .then(() => {
          this.dismissCountDownGetQuote = this.dismissSecs;
          this.QuoteSubmitted = true;
        })
        .catch((err) => {
          throw err;
        });
    },
    resetGetQuote: function () {
      this.QuoteMessage = null;
    },
    GetQuoteToggl() {
      this.isHideQuote = !this.isHideQuote;
      this.QuoteSubject =
        "Max Line Quote : Factory " +
        this.companyId +
        " > " +
        "line " +
        this.lineId +
        " > conveyor " +
        this.conveyorId;
      this.QuoteMessage =
        "Dear " + this.userName +",\n\nThank you for your quotation request for spare-parts for : Factory " +
        this.companyId +
        " > " +
        " line " +
        this.lineId +
        " > conveyor " +
        this.conveyorId +
        "\n\nWe will  provide you with a response on a short notice. If you have any further questions in the meantime, please do not hesitate to contact us.";
      // this.QuoteMessage += "\n\nSpare parts selected :\n" + this.selectedParts;
      this.QuoteMessage += "\n\nBest regards,\n\nMaxim van Gammeren\nSales engineer\nMax-Line services\n";
      this.QuoteMessageHtml = this.QuoteMessage.replace(
        /(?:\r\n|\r|\n)/g,
        "<br />"
      );
    },
    handleChange(e) {
      const { value, checked } = e.target;
      if (checked) {
        this.selectedParts.push(value);
      } else {
        const index = this.selectedParts.findIndex((id) => id === value);
        if (index > -1) {
          this.selectedParts.splice(index, 1);
        }
      }
      this.QuoteSubject =
        "Max Line Quote : Factory " +
        this.companyId +
        " > " +
        "line " +
        this.lineId +
        " > conveyor " +
        this.conveyorId;
      this.QuoteMessage =
      "Dear " + this.userName +",\n\nThank you for your quotation request for spare-parts for : Factory " +
        this.companyId +
        " > " +
        " line " +
        this.lineId +
        " > conveyor " +
        this.conveyorId;
      this.QuoteMessage += "\n\nSpare parts selected :\n" + this.selectedParts.sort();
      this.QuoteMessage += "\n\nWe will  provide you with a response on a short notice. If you have any further questions in the meantime, please do not hesitate to contact us.";
      this.QuoteMessage += "\n\nBest regards,\n\nMaxim van Gammeren\nSales engineer\nMax-Line services\n";
      this.QuoteMessageHtml = this.QuoteMessage.replace(
        /(?:\r\n|\r|\n)/g,
        "<br />"
      );
      // console.log(this.QuoteMessageHtml.replace((/\n/g, "<br />")))
    },
    setTomail(e) {
      this.toSent = e.target.value;
    },
    async UploadHeaderImage() {      
      let formData = new FormData();

      if (this.headerfile != null) {
        if (this.headerfile.size >= '9942880') {
          this.isImageSize = true
          return;
        } else {
          this.isImageSize = false
        }
        // formData.append("file", this.headerfile);

        const FileName = "HeaderImage"
        const photoUrl = URL.createObjectURL(this.headerfile);
        const image = new Image();
        const imageDimensions = await new Promise((resolve) => {
          image.onload = () => {
            const dimensions = {
              height: image.height,
              width: image.width,
            };
            resolve(dimensions);
          };
          image.src = photoUrl;
        });
        var extension = this.headerfile.name.substr(this.headerfile.name.lastIndexOf('.') + 1);
        if(extension == 'jpeg' || extension == 'png'){
          extension = 'jpg'
        }
        if (imageDimensions.width > 1000) {
          const ResizedImage = await new Promise((resolve) => {
            resizeImage({ file: this.headerfile, maxSize: 1000 }).then((resizedImage) => {
              this.url = URL.createObjectURL(resizedImage);
              const cfile = new File([resizedImage], FileName + "."+extension,
                { type: resizedImage.type, lastModified: Date.now() });
              resolve(cfile);
              return cfile;
            }).catch((err) => {
              throw err;
              // console.error(err);
            });
            });

          formData.append("file",  ResizedImage);
        } else {
          formData.append("file", this.headerfile);
        }
        formData.append("FileName", FileName);
        formData.append("extension", extension);
      }
        formData.append("LineNumber", this.lineInfo.lineNumber);
        formData.append("ConveyorNumber", this.lineInfo.conveyorNumber);
        formData.append("CompanyId", this.companyId);
        formData.append("UserId", this.userId);
        let config = {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        };
       
      this.submitted = true;
      
      // Execute Update Conveyor Status
      axios
        .post("line/UploadHeaderImage", formData, config
        )
        .then(() => {
          this.dismissCountDown = this.dismissSecs;
          this.headerfile = null;
          // this.url = null;
          // Reload page with new status
          // this.$emit("statusChange");
        })
        .catch((err) => {
          throw err;
        });
    },
  
    AddToCart(i){
      //console.log(this.lineInfo)
    axios
      .post("shop/addtocart",{
        Category: this.PartsInfo[i].Category,
        Code: this.PartsInfo[i].Code,
        Name: this.PartsInfo[i].Name,
        UserId: this.userId,
        CompanyId: this.companyId,
        Price : this.PartsInfo[i].Price,
        Quantity : this.PartsInfo[i].Quantity,
        MinOrderQty: this.PartsInfo[i].MinOrderQty,
        URL: this.PartsInfo[i].URL,
        addTypeTrack : 2,
      })
      .then(()=>{
        this.PartsInfo[i].productAdded = true;
        axios.get("shop/getcart").then(response =>{
          this.list = response.data;
          //console.log(this.list);
          this.loading = false;
        })
        .catch((err) => {
          throw err;
        });
      })
      .catch((err) => {
        throw err;
      });
      setTimeout(() => {
          this.PartsInfo[i].productAdded = false;
        }, 5000);
  },
  RemoveQty(i){
    if( this.PartsInfo[i].Quantity > 1){
      this.PartsInfo[i].Quantity --;
    }else{
      this.PartsInfo[i].Quantity = 1;
    }
    
  },
  AddQty(i){
    this.PartsInfo[i].Quantity ++;
  },
  AddPartsInfo(){
    this.PartsInfo = [
      {
        Category: this.lineInfo.motorCategory,
        Code: this.lineInfo.motorCode,
        Name: this.lineInfo.motorName,
        Price : this.lineInfo.motorPrice,
        MinOrderQty: this.lineInfo.motorMinOrderQty,
        URL: this.lineInfo.motorImgUrl,
        Quantity : 1,
        productAdded: false,
      },
      { 
        Category: this.lineInfo.driveBearingCategory,
        Code: this.lineInfo.driveBearingCode,
        Name: this.lineInfo.driveBearingName,
        Price : this.lineInfo.driveBearingPrice,
        MinOrderQty: this.lineInfo.driveBearingMinOrderQty,
        URL: this.lineInfo.driveBearingImgUrl,
        Quantity : 1,
        productAdded: false,
      },
      {
        Category: this.lineInfo.idlerBearingCategory,
        Code: this.lineInfo.idlerBearingCode,
        Name: this.lineInfo.idlerBearingName,
        Price : this.lineInfo.idlerBearingPrice,
        MinOrderQty: this.lineInfo.idlerBearingMinOrderQty,
        URL: this.lineInfo.idlerBearingImgUrl,
        Quantity : 1,
        productAdded: false,
      },
      {
        Category: this.lineInfo.chainBeltCategory,
        Code: this.lineInfo.chainBeltCode,
        Name: this.lineInfo.driveBearingName,
        Price : this.lineInfo.chainBeltPrice,
        MinOrderQty: this.lineInfo.chainBeltMinOrderQty,
        URL: this.lineInfo.chainBeltImgUrl,
        Quantity : 1,
        productAdded: false,
      },
      {
        Category: this.lineInfo.driveSprocketCategory,
        Code: this.lineInfo.driveSprocketCode,
        Name: this.lineInfo.driveSprocketName,
        Price : this.lineInfo.driveSprocketPrice,
        MinOrderQty: this.lineInfo.driveSprocketMinOrderQty,
        URL: this.lineInfo.driveSprocketImgUrl,
        Quantity : 1,
        productAdded: false,
      },
      {
        Category: this.lineInfo.idlerSprocketCategory,
        Code: this.lineInfo.idlerSprocketCode,
        Name: this.lineInfo.idlerSprocketName,
        Price : this.lineInfo.idlerSprocketPrice,
        MinOrderQty: this.lineInfo.idlerSprocketMinOrderQty,
        URL: this.lineInfo.idlerSprocketImgUrl,
        Quantity : 1,
        productAdded: false,
      },
      {
        Category: "Curve",
        Code: "Curve",
        Name: "Curve",
        Price : "Curve",
        MinOrderQty: "Curve",
        URL: "Curve",
        Quantity : 1,
        productAdded: false,
      },
      {
        Category: this.lineInfo.wearstripCategory,
        Code: this.lineInfo.wearstripCode,
        Name: this.lineInfo.wearstripName,
        Price : this.lineInfo.wearstripPrice,
        MinOrderQty: this.lineInfo.wearstripMinOrderQty,
        URL: this.lineInfo.wearstripImgUrl,
        Quantity : 1,
        productAdded: false,
      },
      {
        Category: this.lineInfo.rollerCategory,
        Code: this.lineInfo.rollerCode,
        Name: this.lineInfo.rollerName,
        Price : this.lineInfo.rollerPrice,
        MinOrderQty: this.lineInfo.rollerMinOrderQty,
        URL: this.lineInfo.rollerImgUrl,
        Quantity : 1,
        productAdded: false,
      },
      {
        Category: this.lineInfo.componentsCategory,
        Code: this.lineInfo.componentsCode,
        Name: this.lineInfo.componentsName,
        Price : this.lineInfo.componentsPrice,
        MinOrderQty: this.lineInfo.componentsMinOrderQty,
        URL: this.lineInfo.componentsImgUrl,
        Quantity : 1,
        productAdded: false,
      },

    ];
  },
  // PDF Upload
  resetPdf: function() {
    this.headerpdffile = null;
    this.pdfurl = null;
    this.responseData = null;
    this.responseStatus = null;
    this.responseText = null;
    this.isPdfSize = false;
  },
  onFilePdfChange(e) {
    const file = e.target.files[0];
    // this.url = URL.createObjectURL(file);
      this.pdfurl = file.name.toString().replaceAll(' ', '-').split('.').join('-').toLowerCase().substr(0, file.name.lastIndexOf('.'));
    if (file.size >= '5242880') {
      this.isPdfSize = true
      return;
    } else {
      this.isPdfSize = false
    }
  },
  async UploadHeaderPdf() {
    let formData = new FormData();

    if (this.headerpdffile != null) {
      if (this.headerpdffile.size >= '5242880') {
        this.isPdfSize = true
        return;
      } else {
        this.isPdfSize = false
      }
      // formData.append("file", this.headerpdffile);

      const FileName = this.headerpdffile.name.toString().replaceAll(' ', '-').split('.').join('-').toLowerCase().substr(0, this.headerpdffile.name.lastIndexOf('.'));
      // const FileName = "conveyor-" + this.conveyorId;
      const photoUrl = URL.createObjectURL(this.headerpdffile);
      const image = new Image();
      image.src = photoUrl;
      var extension = this.headerpdffile.name.substr(this.headerpdffile.name.lastIndexOf('.') + 1);
      formData.append("file", this.headerpdffile);
      formData.append("FileName", FileName);
      formData.append("extension", extension);
    }
      formData.append("LineNumber", this.lineId);
      // formData.append("ConveyorNumber", this.lineInfo.conveyorNumber);
      formData.append("CompanyId", this.companyId);
      formData.append("UserId", this.userId);
      formData.append("conveyorId", this.conveyorId);
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      
    this.submittedPdf = true;
    
    // Execute Update Conveyor Status
    axios
      .post("line/UploadLinePDF", formData, config
      )
      .then((response) => {
        // console.log(response);
        this.responseData = response.data; // Returned data
        this.responseStatus = response.status; // 200
        this.responseText = response.statusText; // OK
        this.headerpdffile = null;
        // Reload page with new status
        // this.$emit("statusChange");
      })
      .catch((err) => {
        throw err;
      });
  },
  choosePdfFiles() {
      document.getElementById("filePdfUpload").click()
  },

},
beforeMount() {
    if(window.location.hostname === "coms.expert"){
      this.toSent = "info@2bcs.tech";
    }
  },
  mounted() {
    this.$root.$on("BrowserCallBack", () => {
      var url = window.location.href;
      const myArray = url.split("/");
      let lastElement = myArray[myArray.length - 1];
      this.conveyorId = lastElement;
      // this.fetchLineData();
      // this.fetchLineHistory();
      this.$store.dispatch(SET_BREADCRUMB, [
        {
          title: `Home > Line ${this.lineId} > Conveyor ${this.conveyorId}`,
          route: `/line/${this.lineId}/`,
        },
      ]);  
      // console.log(`Home > Line ${this.lineId} > Conveyor ${this.conveyorId}`);
    });
    // this.$root.$on("GoToNext", () => {
    //   // your code goes here
    //   this.headerfile = null;
    //   this.headerpdffile = null;
    //   this.url = null;
    //   this.pdfurl = null;
    //   this.goToHome("next");
    // });
    // this.$root.$on("GoToPrev", () => {
    //   // your code goes here
    //   this.headerfile = null;
    //   this.headerpdffile = null;
    //   this.url = null;
    //   this.pdfurl = null;
    //   this.goToHome("prev");
    // });
    this.fetchLineData();
    this.fetchLineHistory();
    this.fetchPdf();
  },
};
</script>

